<template>
	<div
		v-if="!isBusySetup && fimenu && fimenu.customer && actualStep"
		:class="{ 'fimenubasic': true, 'deal-is-locked': fimenu.isDealLocked(), 'spectator-lock': fimenu.isSpectator }"
		ref="rootRef"
	>
		<!--<PanelWebcam></PanelWebcam>-->
		<IsBusyScreenComponent
			v-if="renderLoadingScreen"
			text="Sending credit application..."
		/>
		<IsBusyScreenComponent
			v-if="isEContracting"
			text="Generating eContract..."
			delayToShowText="3000"
		/>
		<PanelMenu
			v-model:sections="sections"
			class="wizard-container"
			ref="panelMenu"
			:notifications="sectionsNotifications"
			@nextStep="
				section => {
					nextStep = section;
				}
			"
			:sectionLoading="sectionLoading"
		>
			<!--DONE-->
			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Customer)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isCustomerLocked() || isDisabledCustomerInformation()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidCustomerInformation()"
					@continue="customerContinue()"
				>
					<PanelCustomerSection
						:fimenu="fimenu"
						:validation="v$.fimenu"
						ref="customerSection"
					/>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Insurance)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isDisabledInsuranceInformation()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="fimenu.isDealLocked()"
					@continue="insuranceContinue()"
					:continueText="insuranceContinueText()"
				>
					<InsurancePage
						:isAutoCompleteEnabled="isAutoCompleteEnabled"
						:storeCode="fimenu.storeCode"
						:dealId="fimenu.id"
						:dealKind="fimenu.dealKind"
						:customer="fimenu.customer"
						:data="fimenu.insurance"
						:fallbackzipcode="fimenu.store.storeZip"
						:validation="v$.fimenu.insurance"
						:overrideValidation="!fimenu.hasCoverageSelected()"
					/>
				</FIMenuWizardContent>
			</template>

			<!--DONE-->
			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Vehicle)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isVehicleLocked() || isDisabledVehicleInformation()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidVehicleInformation()"
					@continue="vehicleContinue()"
				>
					<div
						:style="$grid('1')"
						class="fade-in"
					>
						<PanelVehicle
							:fimenu
							:panelObject="{ title: `Vehicle ${$global.isAdminView ? `(Style Id: ${fimenu.vehicle?.saturnStyleId})` : ''}` }"
							:notFirstPencil="true"
							:mscanAccount="mscanAccount"
							:spireonEnabled="spireonEnabled"
							:validation="v$.fimenu"
							:skipDBCheck="fimenu.store.storeSettings.useCustomVinDecoder"
							:allowVehicleRefresh="allowVehicleRefresh"
							:disabled="isDealLocked"
						/>
						<!-- <fieldset :disabled="!allowEditVehicleSection"> -->
						<PanelVehicleExtra
							:fimenu
							:panelObject="{ title: 'Vehicle Details' }"
							:showExtra="true"
							:oilTypeChangeAfterPricing="oilTypeChangeAfterPricing"
							:validation="v$.fimenu"
							:oilTypeNotAvailable="oilTypeNotAvailable"
							:skipDBCheck="fimenu.store.storeSettings.useCustomVinDecoder"
							:disabled="lockVehicleVin"
							:refreshCache="refreshBrandsAndModels"
							:vinFailed="vinFailed"
							:overrideVinDetails="overrideVinDetails"
							:swapDropdown="isDealLocked"
							:setWearPricing="rePriceWearIfNeeded"
							ref="vehicleExtraRef"
						/>
						<PanelCarFax
							panelTitle="CarFax Details"
							:dealCarFaxInfo="fimenu.carFax"
							:vin="fimenu.vin"
							:response="carFaxResponse"
							:fimenu="fimenu"
							@updateDealCarFaxInfo="fimenu.carFax = $event"
							@updateDealWarrantyInfo="fimenu.vehicleWarranty.updateUsingVINCarFaxLookup(null, $event)"
							ref="carFax"
						/>
						<PanelSurchargesInQuestion
							:vehicle="fimenu.vehicle"
							:panelObject="{ title: 'Surcharges' }"
							:validation="v$.fimenu.vehicle"
							:panelView="true"
							:isEntity="fimenu.customer.isEntity"
							ref="surchargesPanel"
						/>
						<PanelManufacturerWarranty
							:data="fimenu"
							:panelObject="{ title: 'Original Manufacturer Warranty Details' }"
							:validation="v$.fimenu"
							ref="manufacturerWarranty"
						/>

						<PanelVehicleRecallInfo
							v-if="fimenu.vin"
							:noOpenRecalls="isCarFaxAvailable && !fimenu.carFax.recallExists"
							:vin="fimenu.vin"
							:make="fimenu.vehicle.make"
							:model="fimenu.vehicle.model"
							:modelYear="fimenu.vehicle.modelYear"
							:nhtsaCampaigns="nhtsaCampaignNumbers"
						/>
					</div>
				</FIMenuWizardContent>
			</template>

			<!--DONE-->
			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.TradeIn)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isTradeInLocked() || isDisabledTradeInInformation()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidTradeInformation()"
					@continue="tradeInContinue()"
				>
					<PanelTradeIn
						:fimenu="fimenu"
						:isDisabled="isContinueBusy()"
					/>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Purchase)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isDisabledPurchaseFigures()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidPurchaseFigures()"
					@continue="purchaseContinue()"
				>
					<div
						:style="$grid('1')"
						:class="fimenu.buyersOrderEnabled ? 'purchase-figures-container' : 'purchase-figures-container-nonbo'"
					>
						<PurchaseFiguresPage
							:fimenu
							:validation="v$.fimenu"
							ref="purchaseFigures"
						/>
					</div>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Registration)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isRegistrationLocked() || isDisabledRegistrationInformation()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidRegistration()"
					@continue="RegistrationContinue()"
				>
					<PanelVehicleRegistration
						v-if="fimenu.buyersOrderEnabled"
						:fimenu="fimenu"
						:validation="v$.fimenu"
					/>
				</FIMenuWizardContent>
			</template>

			<!--DONE-->
			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.DealDetails)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isDisabledDealDetails()"
					:fimenuSection="actualStep?.enumValue"
					:continueBusy="isContinueBusy()"
					:continueDisabled="!!fimenu.isDealLocked() || !isValidDealDetails()"
					@continue="dealDetailsContinue()"
				>
					<div :style="$grid('1')">
						<PanelDealDetails
							:fimenu="fimenu"
							:validation="v$.fimenu"
							:mscanAccount="mscanAccount"
						/>
					</div>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.FIMenu)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:fimenuSection="actualStep?.enumValue"
					disableScrollBarMargins
					:continueBusy="isContinueBusy()"
					:continueDisabled="disableFinalButton()"
					@continue="goToFinal()"
				>
					<div class="fade-in fimenu-section-wrapper">
						<IsBusySectionComponent
							v-if="isBusy"
							text="Please wait while we rate the products..."
							delayToShowText="3000"
						></IsBusySectionComponent>
						<PanelFIMenu
							v-else
							:fimenu="fimenu"
							:validation="v$.fimenu"
							:dealSave="($parent as any).dealSave"
							:viewingRole="viewingRole"
							:handleRerate="rateProductsAllForceRepriceAll"
						/>
					</div>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.DealRecap)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="isDisabledRecap()"
					:fimenuSection="actualStep?.enumValue"
					:continueClass="{ pulsing: !disableGetPaperwork() }"
					:continueDisabled="disableGetPaperwork() || !isValidInsurance()"
					:continueBusy="isContinueBusy()"
					:continueText="recapContinueText()"
					@continue="finalizeFI()"
				>
					<PanelFIFinalStep
						:fimenu="fimenu"
						:validation="v$.fimenu"
						:products="fimenu.storeProducts"
					/>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.DealJacket)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:isLocked="!anyPaperwork || isContinueBusy()"
					:fimenuSection="actualStep?.enumValue"
					slotName="wizardButton"
					hideContinue
				>
					<PageDealJacket
						:deal="fimenu"
						:rootName="'Deal #' + fimenu.dealNumber + ' - ' + fimenu.storeCode"
					/>

					<PanelDealChecklist
						v-if="isDealChecklistEnabled"
						:fimenu="fimenu"
						:excludeSectionsAfter="FIMenuSection.DealJacket"
						disablePolling
					/>

					<template #wizardButton>
						<div class="wizard-buttons">
							<TooltipComponent
								:tooltip="dealJacketMoveButtonMessage"
								direction="left"
								maxWidth="500"
							>
								<template #showFromOutside>
									<ButtonLoading
										:isLoading="isBusyChangingStatus || isBusySaving"
										:disabled="dealJacketIsNotReadyForRipper"
										:class="{
											'button-edit': true,
											'final-btn': true,
											'hint-click': canFinalizeForFIAdmin && statusButtonMessageIndex === null,
											'button-unwind': !canFinalizeForFIAdmin && (statusButtonMessageIndex === null || statusButtonMessageIndex === 1),
										}"
										@click="sendToNextDepartment()"
									>
										{{ nextDepartmentButtonMessage }}
									</ButtonLoading>
								</template>
							</TooltipComponent>
						</div>
					</template>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.FIAdmin)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:fimenuSection="actualStep?.enumValue"
					slotName="wizardButton"
					hideContinue
				>
					<div>
						<p>
							<b>
								{{
									canFinalizeForAccounting
										? 'Review the deal items and submit the deal to accounting when completed.'
										: 'This deal has been submitted to the costing clerk.'
								}}
							</b>
						</p>

						<PanelDealChecklist
							v-if="isDealChecklistEnabled"
							:fimenu="fimenu"
							:excludeSectionsAfter="FIMenuSection.FIAdmin"
							disablePolling
						/>
					</div>

					<template #wizardButton>
						<div class="wizard-buttons">
							<ButtonLoading
								v-if="isDealWithFIAdmin && fimenu.buyersOrderEnabled && !fimenu.isSpectator"
								:isLoading="isBusyChangingStatus || isBusySaving"
								:class="{
									'button-edit': true,
									'final-btn': true,
									'hint-click': canFinalizeForAccounting && statusButtonMessageIndex === null,
									'button-unwind': !canFinalizeForAccounting && (statusButtonMessageIndex === null || statusButtonMessageIndex === 1),
								}"
								@click="sendToNextDepartment()"
							>
								{{ nextDepartmentButtonMessage }}
							</ButtonLoading>
						</div>
					</template>
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.Posting)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:fimenuSection="actualStep?.enumValue"
					hideContinue
				>
					<PanelAccounting :fimenu="fimenu" />
				</FIMenuWizardContent>
			</template>

			<template v-slot:[FIMenuSectionEnumsHelper.getName(FIMenuSection.DealAudit)]>
				<FIMenuWizardContent
					:fimenu="fimenu"
					:fimenuSection="actualStep?.enumValue"
					continueClass="button-accept ignore-all-locks"
					continueText="Review"
					:continueDisabled="!selectedForStreaming.length"
					@continue="openStreamingModal()"
				>
					<PanelDealAudit
						:fimenu="fimenu"
						:handleStreams="{
							onSelect: handleStreamSelect,
							list: selectedForStreaming,
							emptyList: resetSelectedForStreaming,
						}"
					/>
				</FIMenuWizardContent>
			</template>

			<template
				v-slot:deal-is-locked
				v-if="!inPostingSection"
			>
				<DealIsLocked
					:lockType="lockType"
					:deal="fimenu"
					v-if="fimenu.isDealLocked() || fimenu.isDealPartiallyLockedBecauseWeSentACreditApp()"
				/>
			</template>
		</PanelMenu>
	</div>
	<IsBusySectionComponent v-else />
</template>
<script lang="ts">
	export interface IFIMenuBasicProps {
		fimenu: FIMenu;
		viewingRole?: string;
		updatePENProducts: () => Promise<void>;
	}
</script>
<script setup lang="ts">
	import _ from 'underscore';
	import settings from 'settings';

	import { isDealDateOutdated, updateDealDate } from '@core/classes/FIMenuHelper';
	import { inject, nextTick, onBeforeMount, onBeforeUnmount, provide, ref, toRef, useSlots, useTemplateRef, watch } from 'vue';
	import { required, maxLength, minLength, minValue, requiredIf, decimal } from '@vuelidate/validators';
	import util, { EventBusCore } from '@core/services/util';
	import {
		validDate,
		validVIN,
		validZIPUS,
		validZIPInternational,
		validSurcharge,
		validInServiceDate,
		validVehicleYear,
		validVehicleMake,
		validLicense,
	} from '@core/services/custom-validators';
	import $modal from '@core/services/modal';
	import api from '@core/services/api/_api';
	import Application from '@core/classes/Applications/Application';
	import auth from '@core/services/auth';
	import { buyersOrderHelper } from '@core/helpers/buyers-order-helper';
	import { EContractStatus } from '@core/classes/EContract';
	import financials from '@core/services/financials';
	import ChecklistHelper from '@/helpers/checklist-helper';
	import CoverageTerm from '@core/classes/CoverageTerm';
	import CoverageTermInfo from '@core/classes/CoverageTermInfo';
	import CoverageTermPricing from '@core/classes/CoverageTermPricing';
	import ENUMS, { OIL_TYPES } from '@core/classes/Enums';
	import FIMenuCreditReport from '@core/classes/FIMenuCreditReport';
	import FIMenuExportInfo from '@core/classes/FIMenuExportInfo';
	import FIMenuPaperwork from '@core/classes/FIMenuPaperwork';
	import { DocAssociation, DealSource, EmployeePermissionsType, FIMenuSection } from '@core/classes/SharedEnums';
	import FIMenuSectionEnumsHelper from '@core/_enums/FIMenuSectionEnumsHelper';
	import PlaidHelper from '@core/helpers/Providers/plaid-helper';
	import { updateInventory } from '@core/classes/FIMenuHelper';
	import { useVuelidate } from '@vuelidate/core';

	import modalFIFinalStep from '@/modals/modalFIFinalStep.vue';
	import modalForVideoStreams from '@/modals/modalForVideoStreams.vue';
	import modalInfo from '@core/modals/modalInfo.vue';
	import modalLender from '@/modals/modalLender.vue';
	import modalOil from '@/modals/modalOil.vue';
	import modalPaperworkErrors from '@/modals/modalPaperworkErrors.vue';
	import modalWarranty from '@/modals/modalWarranty.vue';

	import { BookValue, DealStatuses, PaperworkStatus, PlateTransactionType, VehiclePrimaryUsage } from '@core/classes/SharedEnums';
	import {
		createAdditionalInfoForAllySoftPull,
		CreditApplicationsEnabled,
		DisplayCreditApplication,
		EContractStatusesToNotLetGeneratePaperwork,
		GenerateEContract,
		HandleEContractStatus,
		ManualSubmitCreditApplication,
		OpenEContractStatusModal,
		PurchaseFiguresContinueShouldResubmit,
		PurchaseFiguresContinueSubmit,
		SubmitCreditApplication,
	} from '@core/helpers/finance-channels-helper';
	import FIDealJacketAdditionalInformation, { InventoryTypeValues } from '@core/classes/FIDealJacketAdditionalInformation';
	import { SubmitDealJacket } from '@core/helpers/finance-channels-helper';
	import ButtonLoading from '@core/components/ButtonLoading.vue';
	import { computed } from 'vue';
	import DealDMSData from '@core/classes/Deal/DealDmsData';
	import DealIsLocked from '@/components/DealIsLocked.vue';
	import { DealRoomHubPlugin } from '@core/plugins/dealRoomHub';
	import { Emitter } from 'mitt';
	import { FIDynamicFields } from '@core/classes/FIDynamicFields';
	import { FiltersPlugin } from '@core/services/filters';
	import FIMenu from '@core/classes/FIMenu';
	import FIMenuCustomer from '@core/classes/FIMenuCustomer';
	import { FIMenuCustomersInfo } from '@core/classes/FIMenuCustomersInfo';
	import FIMenuDealEmployee from '@core/classes/FIMenuDealEmployee';
	import FIMenuLeaseTerms from '@core/classes/FIMenuLeaseTerms';
	import FIMenuLoanTerms from '@core/classes/FIMenuLoanTerms';
	import FIMenuLogItem from '@core/classes/FIMenuLogItem';
	import FIMenuVehicleSurcharge from '@core/classes/FIMenuVehicleSurcharge';
	import FIMenuWizardContent from '@/components/fimenu/FIMenuWizardContent.vue';
	import { getValidationForBookValues } from '@/helpers/fimenu-vehicle-helper';
	import { handlePlateTransaction } from '@/helpers/plate-transactions-helper';
	import InsurancePage from '@/components/fimenu/InsurancePage.vue';
	import IsBusyScreenComponent from '@core/components/IsBusyScreenComponent.vue';
	import IsBusySectionComponent from '@core/components/IsBusySectionComponent.vue';
	import { IsPlateTransactionsEnabled } from '@/helpers/plate-transactions-helper';
	import LogRocket from 'logrocket';
	import PageDealJacket from '../PageDealJacket.vue';
	import PanelAccounting from '@/components/PanelAccounting.vue';
	import PanelCarFax from '@core/components/PanelCarFax.vue';
	import PanelCustomerSection from '@/components/PanelCustomerSection.vue';
	import PanelDealAudit from '@/components/PanelDealAudit.vue';
	import PanelDealChecklist from '@/components/PanelDealChecklist.vue';
	import PanelDealDetails from '@/components/PanelDealDetails.vue';
	import PanelFIFinalStep from '@/components/PanelFIFinalStep.vue';
	import PanelFIMenu from '@/components/PanelFIMenu.vue';
	import PanelManufacturerWarranty from '@/components/PanelManufacturerWarranty.vue';
	import PanelMenu from '@/components/PanelMenu/PanelMenu.vue';
	import PanelSurchargesInQuestion from '@/components/PanelSurchargesInQuestion.vue';
	import PanelTradeIn from '@/components/PanelTradeIn.vue';
	import PanelVehicle from '@/components/PanelVehicle.vue';
	import PanelVehicleExtra from '@/components/PanelVehicleExtra.vue';
	import PanelVehicleRecallInfo from '@core/components/PanelVehicleRecallInfo.vue';
	import PanelVehicleRegistration from '@/components/PanelVehicleRegistration.vue';
	import PurchaseFiguresPage from '@/components/fimenu/PurchaseFiguresPage.vue';
	import { SaturnGlobalPlugin } from '@core/classes/StaticClasses';
	import { SaturnMessage } from '@core/classes/SaturnMessage';
	import SaturnResponse from '@core/classes/Responses/SaturnResponse';
	import { SubmitCreditApplicationResponse } from '@core/classes/Responses/SubmitCreditApplicationResponse';
	import TooltipComponent from '@core/components/TooltipComponent.vue';
	import { useMessagesStore } from '@core/stores/MessagesStore';
	import { useRoute } from 'vue-router';
	import { VehicleBookValue } from '@core/classes/VehicleBookValue';

	const { fimenu, updatePENProducts, viewingRole } = defineProps<IFIMenuBasicProps>();
	const $dealRoomHub = inject<DealRoomHubPlugin>('$dealRoomHub');
	const $filters = inject<FiltersPlugin>('$filters');
	const $global = inject<SaturnGlobalPlugin>('$global');
	const $meetingHub = inject<any>('$meetingHub');
	const $route = useRoute();
	const EventBus = inject<Emitter<any>>('EventBus');

	const carfaxRef = useTemplateRef('carFax');
	const customerSectionRef = useTemplateRef('customerSection');
	const manufacturerWarrantyRef = useTemplateRef('manufacturerWarranty');
	const panelMenuRef = useTemplateRef('panelMenu');
	const purchaseFiguresRef = useTemplateRef('purchaseFigures');
	const surchargesPanelRef = useTemplateRef('surchargesPanel');
	const panelVehicleExtraRef = useTemplateRef('vehicleExtraRef');

	const rootRef = useTemplateRef('rootRef');

	/*
	 * FIXME: bandage solution to fix the lack of reactivity that comes with prop drilling.
	 * Shouldn't be an issue once we switch prop drilling with PInia
	 */
	const reactiveFimenu = toRef(() => fimenu);

	const activeCreditApplicationOrLender = ref(false);
	const populatingVehicleDetails = ref(false);
	const dealMakeId = ref<string>(null);
	provide('activeCreditApplicationOrLender', activeCreditApplicationOrLender);
	provide('populatingVehicleDetails', populatingVehicleDetails);
	provide('dealMakeId', dealMakeId);

	const messagesStore = useMessagesStore();
	const carFaxResponse = ref({
		status: null as any,
		description: null as string,
	});
	const isBusySetup = ref(false);
	const isBusyChangingStatus = ref(false);
	const editorSection = ref('');
	const selectedForStreaming = ref([] as any[]);
	const selectedVideos = ref([] as any[]);
	const busyDownloading = ref(false);
	const statusButtonMessageIndex = ref(null as number);
	const statusButtonMessages = ref(['Finalizing...', 'Reverting...']);
	const oilTypeNotAvailable = ref([] as any[]);
	const actualStep = ref(null as any);
	const nextStep = ref(null as any);
	const allowToPrintPaymentSheet = ref(null as any);
	const sectionLoading = ref(false);
	const sections = ref([
		//{ isActive: false, disabled: () => false, valid: this.isValidPresentation, name: 'Presentation', displayName: 'Presentation', indicator: {}, extraInfo: { info: [{ title: 'Deal Type:', value: () => fimenu.dealType, upperCase: true }, { title: 'Vehicle Status:', value: () => fimenu.inventoryType, upperCase: true }] }, onOpen: onChangeSection, notChangeAllowed: () => tradeInBusy() },
		{
			isActive: false,
			disabled: isDisabledCustomerInformation,
			valid: isValidCustomerInformation,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.Customer),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Customer),
			enumValue: FIMenuSection.Customer,
			indicator: {},
			extraInfo: {
				info: [
					{
						title: '',
						display: () => true,
						value: () => fimenu.customer.fullName,
						upperCase: true,
					},
					{
						title: '',
						display: () => !!fimenu.coCustomer?.fullName,
						value: () => fimenu.coCustomer?.fullName,
						upperCase: true,
					},
				],
			},
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Customer),
		},
		{
			isActive: false,
			disabled: isDisabledVehicleInformation,
			valid: isValidVehicleInformation,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.Vehicle),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Vehicle),
			enumValue: FIMenuSection.Vehicle,
			indicator: {},
			extraInfo: fimenu.vin
				? {
						info: [
							{
								title: 'VIN #:',
								value: () => fimenu.vin,
								upperCase: true,
							},
						],
					}
				: null,
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Vehicle),
		},
		{
			isActive: false,
			disabled: isDisabledTradeInInformation,
			valid: isValidTradeInformation,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.TradeIn),
			displayName: () => tradeInMenuDisplayName.value,
			enumValue: FIMenuSection.TradeIn,
			indicator: {},
			onOpen: onChangeSection,
			visible: () => fimenu.buyersOrderEnabled,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.TradeIn),
		},
		{
			isActive: false,
			disabled: isDisabledRegistrationInformation,
			valid: isValidRegistration,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.Registration),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Registration),
			enumValue: FIMenuSection.Registration,
			indicator: {},
			onOpen: onChangeSection,
			visible: () => fimenu.buyersOrderEnabled,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Registration),
		},
		{
			isActive: false,
			disabled: isDisabledPurchaseFigures,
			valid: isValidPurchaseFiguresAndVerified,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.Purchase),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Purchase),
			enumValue: FIMenuSection.Purchase,
			indicator: {},
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Purchase),
		},
		{
			isActive: false,
			disabled: isDisabledInsuranceInformation,
			valid: isValidInsurance,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.Insurance),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Insurance),
			enumValue: FIMenuSection.Insurance,
			indicator: {},
			onOpen: onChangeSection,
			visible: true,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Insurance),
		},
		{
			isActive: false,
			disabled: isDisabledFIMenu,
			valid: isValidfiMenu,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.FIMenu),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.FIMenu),
			enumValue: FIMenuSection.FIMenu,
			indicator: {},
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.FIMenu),
		},
		{
			isActive: false,
			disabled: isDisabledRecap,
			valid: isValidRecap,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.DealRecap),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.DealRecap),
			enumValue: FIMenuSection.DealRecap,
			indicator: {},
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.DealRecap),
		},
		{
			isActive: false,
			disabled: () => {
				if (isContinueBusy()) {
					return true;
				}
				return !anyPaperwork.value;
			},
			valid: () => fimenu.paperworkStatus === PaperworkStatus.Activated,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.DealJacket),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.DealJacket),
			enumValue: FIMenuSection.DealJacket,
			indicator: {},
			onOpen: onChangeSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.DealJacket),
		},
		{
			isActive: false,
			disabled: () => {
				if (isContinueBusy() || !user.value.hasAccessToPermission(EmployeePermissionsType.AccessFIAdmin) || !fimenu.buyersOrderEnabled) {
					return true;
				}
				return fimenu.dealStatus < DealStatuses.FiFinished;
			},
			valid: () => fimenu.dealStatus >= DealStatuses.FiAdminFinished,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.FIAdmin),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.FIAdmin),
			enumValue: FIMenuSection.FIAdmin,
			onOpen: openFiAdminSection,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.FIAdmin),
		},
		{
			isActive: false,
			disabled: () => {
				if (isContinueBusy() || !user.value.hasAccessToPermission(EmployeePermissionsType.ViewPosting) || !fimenu.buyersOrderEnabled) {
					return true;
				}

				return fimenu.dealStatus < DealStatuses.FiAdminFinished;
			},
			onOpen: openAccountingSection,
			valid: () => fimenu.dealStatus >= DealStatuses.AccountingFinished,
			name: getPostingSectionName(),
			displayName: `${FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Posting)} - ${util.toMoment(fimenu.accountingInfo.accountingMonth).format('MMM YYYY')}`,
			enumValue: FIMenuSection.Posting,
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.Posting),
		},
		{
			isActive: false,
			disabled: () => {
				if (isContinueBusy()) {
					return true;
				}
				return false;
			}, //if list of recording == 0 or 1 (because it's the first recording), then return true!
			valid: (): boolean => true,
			name: FIMenuSectionEnumsHelper.getName(FIMenuSection.DealAudit),
			displayName: FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.DealAudit),
			enumValue: FIMenuSection.DealAudit,
			/*                        visible: fimenu.store.storeSettings.isVideoRecordingEnabled,*/
			index: FIMenuSectionEnumsHelper.getOrder(FIMenuSection.DealAudit),
		},
	]);
	const isBusy = ref(false);
	const isBusyFinalButton = ref(false);
	const isBusySaving = ref(false);

	//customerNameValidation: null,
	const creditApplicationsEnabled = ref(false);
	const mscanEnabled = ref(false);
	const mscanAccount = ref(null);
	const spireonEnabled = ref(false);
	const vinFailed = ref(false);
	const refreshBrandsAndModels = ref(false);
	const development = ref(null);
	const submittingCreditApplication = ref(false);
	const isEContracting = ref(false);

	const user = computed(() => auth.getTokenPayload());

	const renderLoadingScreen = computed((): boolean => submittingCreditApplication.value);

	const nextDepartmentButtonMessage = computed((): string => {
		if (statusButtonMessageIndex.value !== null) return statusButtonMessages.value[statusButtonMessageIndex.value];
		else if (!canFinalizeForFIAdmin.value && !canFinalizeForAccounting.value) return 'Take Back Deal Jacket';
		else if (isDealWithFiManager.value) return 'Give Deal Jacket to F&I Admin';
		else return 'Give Deal Jacket to Costing Clerk';
	});

	const sectionsNotifications = computed((): Partial<Record<string, SaturnMessage[]>> => {
		return {
			[FIMenuSectionEnumsHelper.getName(FIMenuSection.Purchase)]: messagesStore
				.getDealMessages()
				.filter(asoc => asoc.relationships.some(r => r.type == DocAssociation.CreditApplication)),
		};
	});

	const canFinalizeForFIAdmin = computed(() => fimenu.dealStatus === DealStatuses.FiInProcess);
	const isAllPaperworkActivated = computed(() => fimenu.paperworkStatus === PaperworkStatus.Activated);
	const canFinalizeForAccounting = computed((): boolean => fimenu.dealStatus === DealStatuses.FiAdminInProcess);
	const isDealWithFiManager = computed(() => fimenu.dealStatusEnumsHelper.isWithFiManager(fimenu.dealStatus));
	const isDealWithFIAdmin = computed(() => fimenu.dealStatusEnumsHelper.isWithFiAdmin(fimenu.dealStatus));

	const inPostingSection = computed((): boolean => {
		const activeSection = sections.value.find(section => section.isActive);
		return activeSection?.name === getPostingSectionName();
	});

	const hasValidLeaseOrLoanTerms = computed((): boolean => !v$.value.fimenu.loanTerms.$invalid && !v$.value.fimenu.leaseTerms.$invalid);
	const anyPaperwork = computed((): boolean => fimenu.paperwork && fimenu.paperwork.packets && fimenu.paperwork.packets.length > 0);
	const anyTermSelected = computed((): boolean => fimenu.coverageTerms.some((c: CoverageTerm) => c.selected == true));

	const visibleSections = computed((): any =>
		sections.value.filter((section: any) => (util.isFunction(section.visible) ? section.visible() : (section.visible ?? true))),
	);

	const tradeInMenuDisplayName = computed(
		(): string => FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.TradeIn) + (fimenu.tradeIns.length > 1 ? ' - ' + fimenu.tradeIns.length : ''),
	);

	const hasPaperwork = computed((): boolean => {
		return (
			fimenu.paperwork != null &&
			fimenu.paperwork.currentPacket() &&
			fimenu.paperwork.currentPacket().documents != null &&
			Array.isArray(fimenu.paperwork.currentPacket().documents) &&
			fimenu.paperwork.currentPacket().documents.length > 0
		);
	});

	const hasPaperworkErrors = computed((): boolean => !(fimenu.paperwork && fimenu.paperwork.currentPacket()));
	const isDealLocked = computed((): boolean => hasPaperwork.value || anyTermSelected.value || fimenu.isInAccountingDepartment);
	const lockType = computed((): any => {
		if (hasPaperwork.value) return 'paperwork';
		if (fimenu.isSpectator) return 'spectator';
		if (fimenu.getSelectedCoverageTerm() != null) return 'coverageSelected';

		if (fimenu.lockByDealStatus()) {
			if (fimenu.isInAccountingDepartment) return 'accounting';
			if (fimenu.isInFinanceDepartment) return 'finance';
			if (fimenu.isInSalesDepartment) return 'sales';
		}

		if (fimenu.isDealPartiallyLockedBecauseWeSentACreditApp()) return 'sentCreditApplication';

		return null;
	});

	const fimenuPropsForBuyersOrder = computed((): any => buyersOrderHelper.getPropsToCompare(fimenu));

	const ratingObjToWatch = computed((): any => fimenu.getRatingObjToWatch());
	const isDealChecklistEnabled = computed((): boolean => ChecklistHelper.isDealChecklistEnabled(fimenu));
	const dealHasFiFinalizedStatus = computed((): boolean => fimenu.dealStatus === DealStatuses.FiFinished);
	const dealHasFiAdminFinalizedStatus = computed(() => fimenu.dealStatus === DealStatuses.FiAdminFinished);
	const lockVehicleVin = computed((): boolean => fimenu.store.storeSettings.lockVehicleVin && !$global.isAdminView);
	const overrideVinDetails = computed((): boolean => fimenu.store.storeSettings.overrideVinDetails || $global.isAdminView);
	const isAutoCompleteEnabled = computed((): any => fimenu.store?.storeSettings?.isAutoCompleteEnabled);
	const isCarFaxAvailable = computed((): any => carFaxResponse.value?.status);

	const nhtsaCampaignNumbers = computed((): any => {
		if (!fimenu?.carFax?.recallExists) return [];
		return fimenu.carFax.recallInfoList.map((r: any) => r.nhtsaNum);
	});

	const allowVehicleRefresh = computed((): boolean => $global.isAdminView && !fimenu.isDealLocked());

	const dealJacketMoveButtonMessage = computed(() => {
		const message = [];
		if (!isAllPaperworkSigned.value) message.push('All paperwork needs to be signed before giving deal to F&I admin.\n');
		if (!isAllPaperworkActivated.value) message.push('All paperwork needs to be activated before giving deal to F&I admin.\n');
		if (!isDealWithFiManager.value) message.push('The deal is with the FI Manager.\n');
		if (fimenu.isSpectator) message.push('Cannot move deal jacket as spectator.\n');
		return message;
	});

	const isAllPaperworkSigned = computed(() => fimenu.isAllPaperworkSigned());

	const dealJacketIsNotReadyForRipper = computed(() => {
		return !(isAllPaperworkActivated.value && isAllPaperworkSigned.value && isDealWithFiManager.value && fimenu.buyersOrderEnabled && !fimenu.isSpectator);
	});

	onBeforeMount(async () => {
		try {
			isBusySetup.value = true;
			const apiCallsToMake = [];
			await initializeCustomerApplicationObjects();

			await loadCustomers();
			checkForCustomerNumbers();

			apiCallsToMake.push(Promise.resolve(fimenu.customer.getAndSetCustomerApplication()));

			if (fimenu.coCustomer.id) {
				apiCallsToMake.push(Promise.resolve(fimenu.coCustomer.getAndSetCustomerApplication()));
			}

			if (fimenu.vehicle.saturnStyleId) {
				loadMakeIdFromStyle();
			}

			if (fimenu.externalDMSDealSaturnId) {
				apiCallsToMake.push(Promise.resolve(setCDKDealInfo()));
			}

			development.value = $route.query.debug == 'true';

			//SIMCHA - CLEANUP. LOADS PRICES AND PROVIDERS
			apiCallsToMake.push(Promise.resolve());

			allowToPrintPaymentSheet.value = fimenu.store.storeSettings.allowToPrintPaymentSheet;

			selectInitialSection();

			watch(
				() => fimenu.customer.isEntity,
				newVal => {
					const commercial = fimenu.vehicle.vehicleSurcharges.find((s: FIMenuVehicleSurcharge) => s.code == ENUMS.VEHICLE_SURCHARGES.COMMERCIAL);
					if (newVal && commercial) {
						commercial.value = true;
					} else if (commercial) {
						commercial.value = null;
					}
				},
			);

			setOilTypesNotAvailable();

			//off for now
			//if (!this.isSelectedOilTypeAvailable() && !fimenu.isDealLocked()) {
			//    this.openModalOil()
			//}
			watch(
				() => ratingObjToWatch.value,
				(newVal, oldVal) => {
					if (newVal.vehicleSurcharges.some((ns: any) => oldVal.vehicleSurcharges.some((os: any) => os.code === ns.code && os.value !== ns.value))) {
						fimenu.ratingStatus = ENUMS.RATING_STATUS.REQUIRED_WITH_SURCHARGE_CHANGE;
					} else {
						fimenu.ratingStatus = ENUMS.RATING_STATUS.REQUIRED;
					}
				},
				{ deep: true },
			);

			creditApplicationsEnabled.value = CreditApplicationsEnabled(fimenu);
			//console.log('partnerCodes', fimenu.store.partnerCodes);
			mscanEnabled.value = fimenu.store.partnerCodes.some((p: any) => p.type === ENUMS.PARTNER_CODES.MSCAN_ACCOUNT);
			spireonEnabled.value = fimenu.store.partnerCodes.some((p: any) => p.type === ENUMS.PARTNER_CODES.SPIREON_ACCOUNT_ID);
			//console.log('mscanEnabled', this.mscanEnabled)
			if (mscanEnabled.value) {
				const account = fimenu.store.partnerCodes.filter((p: any) => p.type === ENUMS.PARTNER_CODES.MSCAN_ACCOUNT);
				//console.log('account', account);
				if (account && account.length > 0) {
					mscanAccount.value = account[0].code;
					//console.log('this.mscanAccount', this.mscanAccount)
				}
			}

			// Subscribe to DealRoomHub Events
			if (fimenu.store.storeSettings.isDealCoBrowsingEnabled) {
				watch(
					() => isBusy.value,
					() => {
						EventBus.emit('fimenuBasicBusy', isBusy.value);
					},
				);

				$dealRoomHub.bulkSubscribe({
					EditorSectionChanged: editorSectionChangedHandler,
					UpdatedRoomInfo: updatedRoomInfoHandler,
				});
			}

			EventBus.on('copiedWarrantyInfo', handleCopiedWarrantyInfo);
			EventBus.on('copiedVehicleExtraInfo', handleCopiedVehicleExtraInfo);
			EventBus.on('populatingVehicleDetails', handlePopulatingVehicleDetails);
			EventBus.on('clearVehicleInformation', clearVehicleInformation);
			EventBus.on('vinFailed', handleFailedVin);
			EventBus.on('refreshBrandsAndModels', handleMakeAndModelRefresh);
			EventBus.on('updateStyleId', loadMakeIdFromStyle);
			EventBus.on('saveCarFaxResponse', handleCarFaxResponse);
			EventBusCore.on('notifyUserDealStructureChanged', onNotifyUserDealStructureChanged);

			fimenu.loJackSearchByVin();
			apiCallsToMake.push(Promise.resolve(getCreditReportWhenInitialized()));

			await Promise.all(apiCallsToMake);

			//CarFax Response
			if (fimenu.carFax.lastOdometerReading !== null) {
				carFaxResponse.value.status = true;
			}
		} catch (error) {
			console.warn(error);
		} finally {
			isBusySetup.value = false;
		}

		// KEEP THIS WAS AT LAST. BECAUSE LOADING FIMENU WOULD MAKE BO NEED TO VERIFY ON INITIAL LOAD.
		//BUYERS ORDER ENABLED
		if (fimenu.buyersOrderEnabled) {
			//BuyersOrder GLOBAL WATCH
			watch(
				() => fimenuPropsForBuyersOrder.value,
				async (newVal, oldVal) => {
					if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
						await buyersOrderHelper.onFIMenuChanged(fimenu, newVal, oldVal);
					}
				},
				{ deep: true },
			);
		}

		// Auto-add employee to deal if role is empty (if they aren't an admin)
		if (!user.value.isAdmin) {
			if (!fimenu.store.storeSettings.isDealCoBrowsingEnabled) {
				fimenu.autoAddUserToVacantRole(user.value.EmployeeCode, user.value.EmployeeName, user.value.Position);
			} else {
				watch(
					() => fimenu.isSpectator,
					currValue => {
						// If spectator, don't auto-add user to employee list
						if (currValue) return;
						fimenu.autoAddUserToVacantRole(user.value.EmployeeCode, user.value.EmployeeName, user.value.Position);
					},
					{ immediate: true },
				);
			}
		}
	});

	onBeforeUnmount(() => {
		$dealRoomHub.bulkUnsubscribe({
			EditorSectionChanged: editorSectionChangedHandler,
			UpdatedRoomInfo: updatedRoomInfoHandler,
		});

		EventBus.off('copiedWarrantyInfo', handleCopiedWarrantyInfo);
		EventBus.off('copiedVehicleExtraInfo', handleCopiedVehicleExtraInfo);
		EventBus.off('populatingVehicleDetails', handlePopulatingVehicleDetails);
		EventBus.off('clearVehicleInformation', clearVehicleInformation);
		EventBus.off('vinFailed', handleFailedVin);
		EventBus.off('refreshBrandsAndModels', handleMakeAndModelRefresh);
		EventBus.off('updateStyleId', loadMakeIdFromStyle);
		EventBus.off('saveCarFaxResponse', handleCarFaxResponse);
		EventBusCore.off('notifyUserDealStructureChanged', onNotifyUserDealStructureChanged);
	});

	/**
	 * Sets the CDK deal info. Fetches the deal from CDK and saves it to the FIMenu.
	 */
	async function setCDKDealInfo() {
		try {
			isBusy.value = true;

			const { data } = await api.fimenu.getExternalDMSDealData(fimenu);
			const { payload, messages, statusCode } = data as SaturnResponse<DealDMSData>;
			if (statusCode !== 200)
				throw Error(messages.join(', '), {
					cause: {
						statusCode,
						messages,
					},
				});

			if (payload) {
				fimenu.setDMSData(payload);
				if (fimenu.dmsData.source !== DealSource.Saturn) {
					sections.value.forEach(s => {
						s.isActive = false;
						s.disabled = () => true;
					});

					sections.value = sections.value.filter(s => (typeof s.visible == 'function' ? s.visible() : true));

					const dealAuditSection = sections.value.findIndex(s => s.enumValue === FIMenuSection.DealAudit);
					if (dealAuditSection !== -1) {
						sections.value[dealAuditSection].isActive = true;
						sections.value[dealAuditSection].disabled = () => false;
						actualStep.value = sections.value[dealAuditSection];
					}
				}
			}
		} catch (error) {
			console.error(error);
			//util.toastr('error', 'Retrieving DMS Deal Info', String(error));
			return;
		} finally {
			isBusy.value = false;
		}
	}
	async function loadCustomers() {
		if (fimenu.paperwork?.packets?.length ?? 0 > 0) return;
		if (fimenu.isDealLocked()) return;
		if (!util.isNullOrEmpty(fimenu.customer?.id)) await fimenu.customer?.reload(false);
		if (!util.isNullOrEmpty(fimenu.coCustomer?.id)) await fimenu.coCustomer?.reload(false);
	}

	function loadMakeIdFromStyle() {
		if (fimenu.vehicle.saturnStyleId) {
			api.settings
				.getMakeByStyle(fimenu.vehicle.saturnStyleId)
				.then(res => (dealMakeId.value = res?.data?.id))
				.catch(err => console.error(err));
		}
	}

	function checkForCustomerNumbers() {
		if (!fimenu.customer.cdkCustomerInfo?.dmsCustomerNumber) insertCustomerIntoCDK(fimenu.customer);
		if (fimenu.hasCoSigner && !fimenu.coCustomer.cdkCustomerInfo?.dmsCustomerNumber) insertCustomerIntoCDK(fimenu.coCustomer);
	}

	function insertCustomerIntoCDK(customer: FIMenuCustomer) {
		api.dataYourWay
			.upsertCustomer({
				storeCode: fimenu.storeCode,
				customerId: customer.id,
				identifications: customer.identifications,
			})
			.then(response => {
				if (response.data.payload) {
					customer.cdkCustomerInfo.dmsCustomerNumber = response.data.payload;
				}
			});
	}

	function handleFailedVin(newValue?: boolean) {
		vinFailed.value = newValue;
		// fimenu.vin = null;
		clearVehicleInformation();
	}

	function handleMakeAndModelRefresh(newValue?: boolean) {
		refreshBrandsAndModels.value = newValue;
	}

	function handlePopulatingVehicleDetails(newValue?: boolean) {
		populatingVehicleDetails.value = newValue;
		if (newValue) {
			vinFailed.value = false;
		}
	}

	function handleCopiedWarrantyInfo(newValue?: any) {
		const glowInputs = manufacturerWarrantyRef.value ? rootRef.value.querySelectorAll('.glow') : null;
		if (glowInputs) util.setInputGlow(glowInputs, newValue ? 'success' : 'error');
	}

	function handleCopiedVehicleExtraInfo(newValue?: any) {
		const glowInputs = panelVehicleExtraRef.value.extraInfoRef ? rootRef.value.querySelectorAll('.glow') : null;
		if (glowInputs) util.setInputGlow(glowInputs, newValue ? 'success' : 'error');
	}

	function handleCarFaxResponse(status?: any, description?: any) {
		carFaxResponse.value.status = status;
		carFaxResponse.value.description = description;
	}

	async function openFiAdminSection() {
		if (dealHasFiFinalizedStatus.value) {
			await fimenu.setDealStatus(DealStatuses.FiAdminInProcess);
		}
	}

	async function openAccountingSection() {
		if (dealHasFiAdminFinalizedStatus.value) {
			await fimenu.setDealStatus(DealStatuses.AccountingInProcess);
		}
	}

	async function sendToNextDepartment(skipChecklist = false) {
		isBusySaving.value = true;
		const canProceed = skipChecklist ? true : await checkChecklist(undefined, () => sendToNextDepartment(true));
		isBusySaving.value = false;

		if (!canProceed) return;

		if (canFinalizeForFIAdmin.value || canFinalizeForAccounting.value) {
			statusButtonMessageIndex.value = 0;
		} else {
			statusButtonMessageIndex.value = 1;
		}

		toggleStatus();
		statusButtonMessageIndex.value = null;
	}

	async function toggleStatus() {
		isBusyChangingStatus.value = true;
		let nextDealStatus = null;
		if (fimenu.dealStatusEnumsHelper.isInAProcessingStep(fimenu.dealStatus)) {
			nextDealStatus = fimenu.dealStatusEnumsHelper.getNextDealStatus(fimenu.dealStatus);
		} else {
			nextDealStatus = fimenu.dealStatusEnumsHelper.getPreviousDealStatus(fimenu.dealStatus);
		}
		let dealStatusUpdated = await fimenu.setDealStatus(nextDealStatus);
		isBusyChangingStatus.value = false;
	}

	// toggleSave(){
	//     this.allowEditVehicleSection = !this.allowEditVehicleSection;
	// }

	function getPostingSectionName() {
		return FIMenuSectionEnumsHelper.getName(FIMenuSection.Posting);
	}

	async function initializeCustomerApplicationObjects() {
		fimenu.customer.customerApplication = new Application();

		//if co signer
		if (fimenu.hasCoSigner && fimenu.coCustomer.customerApplication == null) {
			fimenu.coCustomer.customerApplication = new Application();
		}
	}

	function openStreamingModal() {
		const setOfVideos = [...new Set(selectedForStreaming.value.map(sfs => sfs.who + '|' + sfs.pov))];
		const videosData = setOfVideos.map(pi => {
			const split = pi.split('|');
			const vd: { who?: string; pov?: string; videos?: any } = {
				who: split[0],
				pov: split[1],
			};
			vd.videos = selectedForStreaming.value
				.filter(sfs => sfs.who === vd.who && sfs.pov === vd.pov)
				.map(sfs => ({
					url: sfs.streamUrl,
					start: sfs.startTime,
					end: sfs.finishTime,
				}));
			return vd;
		});
		$modal.open(modalForVideoStreams, {
			name: 'modalForVideoStreams',
			passedData: { videosData, events: null, postFunction: null },
		});
	}

	function handleStreamSelect(videoDetails?: any) {
		//if vidDetails is already in the array, remove it and return;
		const index = selectedForStreaming.value.findIndex(selected => selected.blobName === videoDetails.blobName);

		if (index === -1) {
			selectedForStreaming.value.push(videoDetails);
		} else {
			selectedForStreaming.value.splice(index, 1);
		}
	}

	function isCustomerLocked() {
		// This only takes care of disabling inputs.
		return false;
	}

	function isVehicleLocked() {
		// This only takes care of disabling inputs.
		return false;
	}

	function isTradeInLocked() {
		// This only takes care of disabling inputs.
		return false;
	}

	function isRegistrationLocked() {
		// This only takes care of disabling inputs.
		return false;
	}

	function openModalOil() {
		$modal.open(modalOil, {
			name: 'modalOil',
			passedData: {
				oilTypeNotAvailable: oilTypeNotAvailable.value,
				fimenu: fimenu,
				info: ENUMS.oilTypes.find(o => o.value == fimenu.vehicleOil).display + ' is NOT available. Please select another oil type.',
				acceptText: 'OK',
			},
			backdrop: false,
			postFunction: oilTypeChangeAfterPricing,
		});
	}

	function isContinueBusy() {
		return fimenu.buyersOrderIsBusy || isBusySaving.value;
	}

	function developmentMode() {
		return settings.environmentName != 'PRODUCTION' || $route.query.debug == 'true';
	}

	function oilTypeChangeAfterPricing() {
		if (fimenu.hasCoverageTerms()) {
			fimenu.priceProducts([{ productType: ENUMS.PRODUCT_TYPES.MAINTENANCE }]).then(() => {
				setOilTypesNotAvailable();
				dealSave();
			});
		}
	}

	function isDisabledCustomerInformation() {
		if (isContinueBusy()) {
			return true;
		}

		return false;
	}

	function isValidCustomerInformation() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		if (v$.value.fimenu) {
			return !(
				v$.value.fimenu.customer.$invalid ||
				v$.value.fimenu.hasCoSigner.$invalid ||
				(v$.value.fimenu.coCustomer && v$.value.fimenu.coCustomer.$invalid) ||
				v$.value.fimenu.language.$invalid ||
				v$.value.fimenu.customersInfo.$invalid
			);
		} else {
			return null;
		}
	}

	function isDisabledRegistrationInformation() {
		if (!v$.value.fimenu) {
			return false;
		}

		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.buyersOrderEnabled) {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.TradeIn)) &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidTradeInformation()
			);
		} else {
			return false;
		}
	}

	function isDisabledInsuranceInformation() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}

		if (fimenu.buyersOrderEnabled) {
			const isDealReady = fimenu.dealStatus >= DealStatuses.SalesManagerFinished;

			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Purchase)) &&
				isDealReady &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidRegistration() &&
				isValidTradeInformation() &&
				isValidPurchaseFiguresAndVerified()
			);
		} else {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Purchase)) &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidPurchaseFigures()
			);
		}
	}

	function isValidInsurance() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		if (v$.value.fimenu) return !v$.value.fimenu.insurance.$invalid;
		else return null;
	}

	function isValidRegistration() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}
		if (v$.value.fimenu) {
			if (fimenu.buyersOrderEnabled) {
				return !(v$.value.fimenu.dealAddresses.$invalid || v$.value.fimenu.dealAddressesQuestions.$invalid || v$.value.fimenu.vehicle.registrationInfo.$invalid);
			} else {
				return false;
			}
		} else {
			return null;
		}
	}

	function isDisabledVehicleInformation() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}

		return !(stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Customer)) && isValidCustomerInformation());
	}

	function isValidVehicleInformation() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		if (v$.value.fimenu) {
			const isAnyInputInvalid =
				v$.value.fimenu.vehicle.modelYear.$invalid ||
				v$.value.fimenu.vehicle.make.$invalid ||
				v$.value.fimenu.vehicle.model.$invalid ||
				v$.value.fimenu.vehicle.hasFiveDigitOdometer.$invalid ||
				v$.value.fimenu.vehicle.mileageStatus.$invalid ||
				v$.value.fimenu.vehicle.milesPerYear.$invalid ||
				v$.value.fimenu.vehicle.fuelType.$invalid ||
				v$.value.fimenu.vehicle.exteriorColor.$invalid ||
				v$.value.fimenu.vehicle.primaryBodyType.$invalid ||
				v$.value.fimenu.vehicle.otherVehicleInfo.$invalid ||
				v$.value.fimenu.vin.$invalid ||
				v$.value.fimenu.stockNumber.$invalid ||
				v$.value.fimenu.vehicleOil.$invalid ||
				v$.value.fimenu.vehicleMiles.$invalid ||
				v$.value.fimenu.vehicle.vehicleSurcharges.$invalid ||
				(!fimenu.buyersOrderEnabled && v$.value.fimenu.vehicle.bookValues.$invalid) ||
				v$.value.fimenu.inventoryType.$invalid ||
				//v$.value.fimenu.msrp.$invalid ||
				v$.value.fimenu.vehicleWarranty.warrantyStartDate.$invalid ||
				v$.value.fimenu.vehicleWarranty.warranties.basic.miles.$invalid ||
				v$.value.fimenu.vehicleWarranty.warranties.basic.months.$invalid ||
				v$.value.fimenu.vehicleWarranty.warranties.drivetrain.miles.$invalid ||
				v$.value.fimenu.vehicleWarranty.warranties.drivetrain.months.$invalid ||
				v$.value.fimenu.vehicleWarranty.isLoanerIncluded.$invalid;
			return !isAnyInputInvalid;
		} else {
			return null;
		}
	}

	function isDisabledTradeInInformation() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}

		if (fimenu.buyersOrderEnabled) {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Vehicle)) &&
				isValidCustomerInformation() &&
				//&& this.isValidInsuranceAndRegistration()
				isValidVehicleInformation()
			);
		} else {
			return false;
		}
	}

	function isValidTradeInformation() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}
		if (!v$.value.fimenu.tradeIns.$invalid && !v$.value.fimenu.hasOtherTradeIns.$invalid) {
			return true;
		}
		return false;
	}

	function isDisabledPurchaseFigures() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}
		if (fimenu.buyersOrderEnabled) {
			const isDealReady = fimenu.dealStatus >= DealStatuses.SalesFinished;

			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Registration)) &&
				isDealReady &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidTradeInformation() &&
				isValidRegistration()
			);
		} else {
			return !(stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Vehicle)) && isValidCustomerInformation() && isValidVehicleInformation());
		}
	}

	function isValidPurchaseFigures() {
		if (v$.value.fimenu) {
			if (fimenu.buyersOrderEnabled) {
				const currentBuyersOrder = fimenu.getCurrentBuyersOrder();

				const lenderIsInvalid =
					v$.value.fimenu.loanTerms.maxDaysToFirstPayment.$invalid || v$.value.fimenu.lender.$invalid || !activeCreditApplicationOrLender.value;
				const isLeaseTermsInvalid = fimenu.isLease() ? v$.value.fimenu.leaseTerms.$invalid : false;
				const isLoanTermsInvalid = fimenu.isFinance() ? v$.value.fimenu.loanTerms.$invalid : false;
				const bookValuesInvalid = v$.value.fimenu.vehicle.bookValues.$invalid;
				return (
					currentBuyersOrder &&
					currentBuyersOrder.isValid() &&
					currentBuyersOrder.areAllBucketsValid() &&
					!lenderIsInvalid &&
					!isLeaseTermsInvalid &&
					!isLoanTermsInvalid &&
					!bookValuesInvalid
				);
			} else {
				return !(
					v$.value.fimenu.loanTerms.maxDaysToFirstPayment.$invalid ||
					v$.value.fimenu.lender.$invalid ||
					v$.value.fimenu.preloads.$invalid ||
					v$.value.fimenu.otdBase.$invalid ||
					v$.value.fimenu.sellingPrice.$invalid
				);
			}
		} else {
			return null;
		}
	}

	function isValidPurchaseFiguresAndVerified() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		if (!isValidPurchaseFigures()) {
			return false;
		}

		if (fimenu.buyersOrderEnabled) {
			return fimenu.isBuyersOrderVerified;
		} else {
			return true;
		}
	}

	function isDisabledLender() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}

		if (fimenu.buyersOrderEnabled) {
			return (
				!(
					stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Purchase)) &&
					isValidCustomerInformation() &&
					isValidVehicleInformation() &&
					isValidTradeInformation() &&
					isValidRegistration() &&
					isValidPurchaseFigures()
				) ||
				(fimenu.buyersOrderUpdateRequired && !fimenu.isBuyersOrderVerified)
			);
		} else {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Purchase)) &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidPurchaseFigures()
			);
		}
	}

	function isDisabledDealDetails() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}

		if (fimenu.buyersOrderEnabled) {
			return (
				!(
					stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.TradeIn)) &&
					isValidCustomerInformation() &&
					isValidVehicleInformation() &&
					isValidTradeInformation()
				) ||
				(fimenu.buyersOrderUpdateRequired && !fimenu.isBuyersOrderVerified)
			);
		} else {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Lender)) &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidPurchaseFigures()
			);
		}
	}

	function isDisabledFIMenu() {
		if (isContinueBusy()) {
			return true;
		}
		const isDealReady = fimenu.dealStatus >= DealStatuses.SalesManagerFinished;

		if (fimenu.hasCoverageTermOrPaperwork() || !v$.value.fimenu) {
			return false;
		}
		if (fimenu.buyersOrderEnabled) {
			return (
				!(
					stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Insurance)) &&
					isDealReady &&
					user.value.hasAccessToPermission(EmployeePermissionsType.FIManagerChecklist) &&
					isValidCustomerInformation() &&
					isValidVehicleInformation() &&
					isValidTradeInformation() &&
					isValidInsurance() &&
					isValidRegistration() &&
					isValidPurchaseFiguresAndVerified()
				) ||
				(fimenu.buyersOrderUpdateRequired && !fimenu.isBuyersOrderVerified)
			);
		} else {
			return !(
				stepPreviouslyCompleted(FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.Insurance)) &&
				isValidCustomerInformation() &&
				isValidVehicleInformation() &&
				isValidInsurance() &&
				isValidPurchaseFigures()
			);
		}
	}

	function isDisabledRecap() {
		if (isContinueBusy()) {
			return true;
		}

		if (fimenu.hasCoverageTermOrPaperwork()) {
			return false;
		}
		if (fimenu.buyersOrderEnabled && !user.value.hasAccessToPermission(EmployeePermissionsType.ViewDealRecap) && fimenu.dealStatus < DealStatuses.FiFinished) {
			return true;
		}
		return true;
	}

	function isValidDealDetails() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		return !v$.value.fimenu.preloads.$invalid;
	}

	function isValidfiMenu() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}

		return anyTermSelected.value;
	}

	function isValidRecap() {
		if (fimenu.hasPaperworkPacket()) {
			return true;
		}
		return !v$.value.fimenu.$invalid && anyTermSelected.value && fimenu.hasPaperworkPacket();
	}

	function recapContinueText() {
		if (fimenu.hasPaperworkPacket()) {
			return 'Continue';
		} else {
			// IF we are eContracting and we dont have an eContract status of GenerationComplete,
			// then we need to show the continue button.
			if (isEContracting.value && fimenu.dealJacket.eContract?.status != EContractStatus.GenerationComplete) {
				// Based on the status we can show different text.
				switch (fimenu.dealJacket.eContract?.status) {
					case EContractStatus.ValidationInProgress:
						return 'Validating eContract...';
					case EContractStatus.GenerationInProgress:
						return 'Generating eContract...';
					case EContractStatus.GenerationFailed:
						return 'Failed to generate eContract. Please contact support.';
					case EContractStatus.GenerationComplete:
						return 'Get Paperwork';
					default:
						return 'Continue';
				}
			}
			return 'Get Paperwork';
		}
	}

	function insuranceContinueText() {
		if (
			fimenu.buyersOrderEnabled &&
			!user.value.hasAccessToPermission(EmployeePermissionsType.ViewInsuranceInformation) &&
			fimenu.dealStatus < DealStatuses.SalesManagerFinished
		) {
			return 'Send Deal Jacket to F&I';
		} else {
			return 'Continue';
		}
	}

	function stepPreviouslyCompleted(step?: any) {
		return fimenu.log.some((log: FIMenuLogItem) => log.what == `${step} ${ENUMS.LOG_WHAT.STEP_FINISHED}`);
	}

	function moveToLastAccessibleSection() {
		//SET ALL SECTIONS AS INACTIVE
		sections.value.forEach(s => (s.isActive = false));
		sections.value = sections.value.filter(s => (typeof s.visible == 'function' ? s.visible() : true));

		//FIND AN INVALID SECTION - and choose that one
		const firstInvalidSectionIndex = sections.value.findIndex(s => !s.disabled() && !s.valid());

		if (fimenu.hasPaperworkPacket()) {
			sections.value.find(s => s.name === FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.DealJacket)).isActive = true;
			actualStep.value = FIMenuSectionEnumsHelper.getDisplay(FIMenuSection.DealJacket);
		} else if (firstInvalidSectionIndex >= 0) {
			sections.value[firstInvalidSectionIndex].isActive = true;
			actualStep.value = sections.value[firstInvalidSectionIndex].name;
		} else {
			sections.value[0].isActive = true;
			actualStep.value = sections.value[0].name;
		}

		updateRatesIfNeeded();
	}

	function onChangeSection() {
		updateRatesIfNeeded();

		if (!fimenu.isSpectator) {
			nextTick(() => {
				const currentSection = sections.value[sections.value.findIndex(s => s.isActive === true)].name;
				if ($dealRoomHub.connected) $dealRoomHub.changeEditorSection(currentSection);
			});
		}

		// this.allowEditVehicleSection = false;
	}

	function changeSection() {
		if (fimenu.buyersOrderEnabled && fimenu.buyersOrderUpdateRequired) buyersOrderHelper.resetBuyersOrderInTheBackground(fimenu);

		if (actualStep.value) {
			const previousStepValue = actualStep.value.enumValue;

			if (nextStep.value) {
				sections.value.forEach(s => (s.isActive = s.enumValue == nextStep.value.enumValue));
				actualStep.value = nextStep.value;
			} else {
				actualStep.value = sections.value[sections.value.findIndex(s => s.isActive)];
			}

			nextStep.value = null;
			if (actualStep.value.enumValue != previousStepValue) {
				fimenu.addToLog(
					FIMenuSectionEnumsHelper.getDisplay(actualStep.value.enumValue),
					ENUMS.LOG_HOW.SECTION.CHANGED,
					`${ENUMS.LOG_WHAT.STEP_CHANGED} ${FIMenuSectionEnumsHelper.getDisplay(previousStepValue)}`,
				);
			}
		}
	}

	function updateActiveSection(currentSection?: any) {
		sections.value.forEach(s => (s.isActive = s.name === currentSection.name));
	}

	function editorSectionChangedHandler(currentSection?: any) {
		if (actualStep.value.name === currentSection) return;

		editorSection.value = currentSection;
		const section = sections.value[sections.value.findIndex(s => s.name === currentSection)];

		if (!actualStep.value) {
			actualStep.value = section;
		} else {
			nextStep.value = section;
			changeSection();
		}
	}

	function updatedRoomInfoHandler(roomInfo?: any, viewerInfo?: any) {
		if (viewerInfo.followEditor) editorSectionChangedHandler(roomInfo.editorSection);
	}

	function selectInitialSection() {
		//SET ALL SECTIONS AS INACTIVE
		sections.value.forEach(s => (s.isActive = false));
		sections.value = sections.value.filter(s => (typeof s.visible == 'function' ? s.visible() : true));

		// Show always the first section, Customer Section,   we need this to avoid any video recording lost time
		// check more info in MultiStreamRecorder.vue comments
		sections.value[0].isActive = true;
		actualStep.value = sections.value[0];

		updateRatesIfNeeded();
	}

	async function customerContinue() {
		const idvEnabled = fimenu.store.storeSettings.isCustomerPlaidIDVEnabled;
		const noCustomerApp = fimenu.customerApplication === ENUMS.CUSTOMER_RETRIEVAL_STATUS.NoApplication;
		const isCBCEnabled = fimenu.store.storeSettings.isCBCEnabled;

		isBusySaving.value = true;

		try {
			// If a Customer record was created during an IDV check, make sure the index is up-to-date
			if (idvEnabled && noCustomerApp /*|| isCBCEnabled*/) {
				if (fimenu.customer.id) {
					await api.customers.saveCustomerFromFIMenu(fimenu.customer);
					if (fimenu.customer.creditReport?.id != null) {
						await fimenu.customer?.creditReport?.saveFlags(fimenu.customer.id);
					}
				}
				if (fimenu.coCustomer.id) {
					await api.customers.saveCustomerFromFIMenu(fimenu.coCustomer);
					if (fimenu.coCustomer.creditReport?.id != null) {
						await fimenu.coCustomer?.creditReport?.saveFlags(fimenu.coCustomer.id);
					}
				}
			}

			// Check if we need to open the IDV skip modal
			if (idvEnabled) {
				const customers = [fimenu.customer];
				if (fimenu.hasCoSigner) customers.push(fimenu.coCustomer);

				const isIdvValid = await PlaidHelper.checkForCustomerIdv(fimenu.store, customers, user.value.EmployeeCode, user.value.EmployeeName, null, true);
				if (!isIdvValid)
					throw new Error('IDV Invalid.', {
						cause: 'Customers do not have a valid IDV session. Sessions need to be skipped in order to proceed.',
					});
			}

			const activeSection = visibleSections.value.find((s: any) => s.isActive);
			if (!isValidCustomerInformation())
				throw new Error('Customer Section Invalid.', {
					cause: 'Customer Section did not pass validation rules. Cannot proceed.',
				});

			await handleContinue();
		} catch (err) {
			console.error('Error when Continuing from Customer Section.', err);
			util.toastr(
				'error',
				'Customer Error',
				'An error occurred when trying to validate customer data. Please ensure all customer info is valid before proceeding.',
			);
		} finally {
			isBusySaving.value = false;
		}
	}

	async function insuranceContinue() {
		await handleContinue();
	}

	async function RegistrationContinue() {
		if (fimenu.vehicle.registrationInfo.primaryUsage != VehiclePrimaryUsage.EXPORT) {
			fimenu.vehicle.registrationInfo.freightForwarderInfo = new FIMenuExportInfo();
			fimenu.vehicle.registrationInfo.shippingCompanyInfo = new FIMenuExportInfo();
		}
		const handleChangeStatus = async () => {
			if (user.value.hasAccessToPermission(EmployeePermissionsType.ViewPurchaseFigures)) {
				await fimenu.setDealStatus(DealStatuses.SalesManagerInProcess);
				await handleContinue(false, false);
			}
		};

		const dealStatusIsReadyForSalesMgr = fimenu.dealStatus <= DealStatuses.SalesFinished;
		if (fimenu.buyersOrderEnabled) {
			if (dealStatusIsReadyForSalesMgr) {
				const submitMessage = 'Would you like to submit this quote to the Sales Manager?';
				util.modalConfirmation(submitMessage, 'Submit', handleChangeStatus, 'Cancel', null, 'Submit to Sales Manager');
			} else {
				await handleContinue();
			}
		} else {
			await handleContinue();
		}
	}

	async function vehicleContinue() {
		if (isDealChecklistEnabled.value && !fimenu.canSave()) {
			// Indicates that this is the first time we're clicking continue on the Vehicle section, meaning the deal hasn't been saved yet.
			// We can't fetch pending checklist items until we have deal data in Elastic.

			await dealSave(true);
			await handleContinue(false, true, true);
		} else {
			await handleContinue();
		}

		// If Trade-In section is not available (currently tied to Buyer's Order), start AutoComplete case here
		if (isAutoCompleteEnabled.value && !fimenu.buyersOrderEnabled) {
			isBusySaving.value = true;
			await startAutoCompleteScan(true);
			isBusySaving.value = false;
		}
	}

	async function tradeInContinue() {
		// Currently, Trade-In section is tied to Buyer's Order
		if (isAutoCompleteEnabled.value && fimenu.buyersOrderEnabled) {
			isBusySaving.value = true;
			await startAutoCompleteScan(true);
			isBusySaving.value = false;
		}

		await handleContinue();
	}

	async function purchaseContinue() {
		if (!fimenu.buyersOrderEnabled) {
			await handleContinue();
			return;
		}

		if (await fimenu.checkForFraud()) return;

		const dealStatusIsSalesManagerFinished = fimenu.dealStatus <= DealStatuses.SalesManagerFinished;
		if (dealStatusIsSalesManagerFinished) {
			const _handleChangeStatus = async () => {
				if (user.value.hasAccessToPermission(EmployeePermissionsType.SalesManagerChecklist)) {
					await fimenu.setDealStatus(DealStatuses.FiInProcess);
					return await handleContinue(true, false);
				}
			};

			const _submitToFinance = () => {
				const submitMessage = 'Would you like to submit this quote to the Finance Department?';
				util.modalConfirmation(submitMessage, 'Submit', _handleChangeStatus, 'Cancel', null, 'Submit to F&I Dept.');
			};

			isBusySaving.value = true;
			const canProceed = await checkChecklist(undefined, _handleChangeStatus);
			isBusySaving.value = false;

			if (!canProceed) return;

			_submitToFinance();
		} else {
			await handleContinue();
		}

		const shouldResubmit = PurchaseFiguresContinueShouldResubmit(fimenu, $global.selectedStore);
		if (shouldResubmit) {
			submittingCreditApplication.value = true;
			await PurchaseFiguresContinueSubmit(fimenu, $global.Lenders);
			submittingCreditApplication.value = false;
		}

		fimenu.isBuyersOrderVerified = true;
	}

	async function dealDetailsContinue() {
		await handleContinue();
	}

	async function lenderContinue() {
		await handleContinue();
	}

	async function handleContinue(skipChecklist = false, goToNextSection = true, skipSave = false) {
		isBusySaving.value = true;
		const canProceed = skipChecklist ? true : await checkChecklist(goToNextSection);
		isBusySaving.value = false;

		// Don't change section if there's pending checklist items
		if (!canProceed) return;

		const sections = visibleSections.value;
		const currentStepIndex = sections.findIndex((section: any) => section.isActive);
		const currentSection = sections[currentStepIndex];
		const nextSection = sections[currentStepIndex + 1];

		fimenu.addToLog(
			FIMenuSectionEnumsHelper.getDisplay(currentSection.enumValue),
			ENUMS.LOG_HOW.SECTION.CLOSED,
			`${FIMenuSectionEnumsHelper.getDisplay(currentSection.enumValue)} ${ENUMS.LOG_WHAT.STEP_FINISHED}`,
		);

		if (!goToNextSection) {
			await dealSave();
			return;
		}

		fimenu.addToLog(
			FIMenuSectionEnumsHelper.getDisplay(nextSection.enumValue),
			ENUMS.LOG_HOW.SECTION.OPENED,
			`${FIMenuSectionEnumsHelper.getDisplay(nextSection.enumValue)} ${ENUMS.LOG_WHAT.STEP_STARTED}`,
		);

		// SAVE THE DEAL
		if (!skipSave) await dealSave();

		currentSection.isActive = false;
		nextSection.isActive = true;

		updateRatesIfNeeded();

		actualStep.value = nextSection;

		if ($dealRoomHub.connected && !fimenu.isSpectator) $dealRoomHub.changeEditorSection(actualStep.value.name);
	}

	async function dealSave(forceSave: boolean = false) {
		if (!fimenu.canSave() && !forceSave) return;

		isBusySaving.value = true;
		try {
			await fimenu.save(forceSave);
		} catch (e) {
			console.error('error', e);
		} finally {
			isBusySaving.value = false;
		}
	}

	async function checkChecklist(goToNextSection = true, postFunction?: () => unknown) {
		if (!isDealChecklistEnabled.value) return true;

		const sections = visibleSections.value;
		const currentStepIndex = sections.findIndex((section: any) => section.isActive);
		const currentSection = sections[currentStepIndex];

		if (postFunction == null) postFunction = () => handleContinue(true, goToNextSection);

		return await ChecklistHelper.canContinueFromSection(fimenu, currentSection.enumValue, postFunction);
	}

	function rePriceWearIfNeeded() {
		//If not in threshold, reprice.
		if (
			fimenu.coverageTerms?.length > 0 &&
			!checkNSDMinMaxMSRP(fimenu.getMSRPOrHighestOrDefaultRetailBookValue()?.retail ?? fimenu.getMSRP(), fimenu.coverageTerms[0].wearInfo.program.code)
		) {
			fimenu.priceProducts([{ productType: ENUMS.PRODUCT_TYPES.EXCESS_WEAR_AND_TEAR }]);
		}
	}

	function checkNSDMinMaxMSRP(msrp: number, plancode?: string) {
		let returnValue = false;
		if (msrp < 40000 && (plancode === 'P' || plancode === 'V')) returnValue = true;
		if (msrp >= 40000 && msrp < 75000 && (plancode === 'Q' || plancode === 'W')) returnValue = true;
		if (msrp >= 75000 && msrp < 150000 && (plancode === 'R' || plancode === 'X')) returnValue = true;
		return returnValue;
	}

	function addCustomTerm(copyFromTerm: any) {
		//console.log('in addCustomTerm', copyFromTerm);
		if (!fimenu.hasCustomCoverage && copyFromTerm) {
			let coverageTermCustom = new CoverageTerm();
			//if (this.isLease()) {
			//    coverageTermCustom.wear = true;
			//    coverageTermCustom.wearPricing = new CoverageTermPricing();
			//    coverageTermCustom.wearInfo = new CoverageTermInfo();
			//    coverageTermCustom.gap = false;
			//    coverageTermCustom.gapPricing = new CoverageTermPricing();
			//    coverageTermCustom.gapInfo = new CoverageTermInfo();
			//}
			//else if (this.isFinance()) {
			//    coverageTermCustom.wear = false;
			//    coverageTermCustom.wearPricing = new CoverageTermPricing();
			//    coverageTermCustom.wearInfo = new CoverageTermInfo();
			//    coverageTermCustom.gap = true;
			//    coverageTermCustom.gapPricing = new CoverageTermPricing();
			//    coverageTermCustom.gapInfo = new CoverageTermInfo();
			//}
			//else {
			coverageTermCustom.wear = true;
			coverageTermCustom.wearPricing = new CoverageTermPricing();
			coverageTermCustom.wearInfo = new CoverageTermInfo();
			coverageTermCustom.gap = true;
			coverageTermCustom.gapPricing = new CoverageTermPricing();
			coverageTermCustom.gapInfo = new CoverageTermInfo();
			//}
			//if (copyFromTerm && copyFromTerm > 0) {
			const copyFrom = fimenu.coverageTerms.find((t: any) => t.term === copyFromTerm);
			if (copyFrom) coverageTermCustom = new CoverageTerm(copyFrom);
			coverageTermCustom.preferred = false;
			coverageTermCustom.selected = false;
			//}
			coverageTermCustom.term = 0;
			fimenu.coverageTerms.push(coverageTermCustom);
		}
	}

	function setOilTypesNotAvailable() {
		const responseRates = fimenu.getApiResponseDetails(ENUMS.PRODUCT_TYPES.MAINTENANCE, 'USW')?.flattenedRates;
		if (responseRates && responseRates.length > 0) {
			const selectedTermPlan = responseRates[0];
			const surcharge = JSON.parse(selectedTermPlan.meta['Surcharge']);

			if (surcharge.syntheticOilBlend == null && surcharge.syntheticOil != null) {
				oilTypeNotAvailable.value = [OIL_TYPES.REGULAR];
			}
			if (surcharge.syntheticOilBlend == null && surcharge.syntheticOil == null) {
				oilTypeNotAvailable.value = [OIL_TYPES.REGULAR, OIL_TYPES.BLEND];
			}
		}
	}

	function isSelectedOilTypeAvailable() {
		return !oilTypeNotAvailable.value.includes(fimenu.vehicleOil);
	}

	function disableFinalButton() {
		return (
			!anyTermSelected.value ||
			hasPaperwork.value ||
			(fimenu.isLease() && fimenu.leaseTerms && fimenu.leaseTerms.acceptedTerm == null) ||
			(fimenu.isFinance() && fimenu.loanTerms && fimenu.loanTerms.acceptedTerm == null) ||
			fimenu.isSpectator ||
			!user.value.hasAccessToPermission(EmployeePermissionsType.ViewInsuranceInformation)
		);
	}

	function disableGetPaperwork() {
		const requiredEmployees = [ENUMS.DEAL_EMPLOYEE_ROLE_TYPES.SALES_PERSON1, ENUMS.DEAL_EMPLOYEE_ROLE_TYPES.SALES_MANAGER, ENUMS.DEAL_EMPLOYEE_ROLE_TYPES.FI_MANAGER];

		// Assumes there's no role duplicates.
		const matchingEmployees = fimenu.employees.reduce((sum?: any, currValue?: any) => {
			if (requiredEmployees.includes(currValue.dealRole)) sum++;
			return sum;
		}, 0);

		// Block cause eContracting.
		const localIsEContracting =
			(fimenu.isEContracting &&
				fimenu.isEContractEnabled &&
				fimenu?.dealJacket?.eContract?.id != null &&
				EContractStatusesToNotLetGeneratePaperwork.includes(fimenu?.dealJacket?.eContract?.status)) ||
			isEContracting.value;

		return !!(
			fimenu.hasPaperworkPacket() ||
			isBusySaving.value ||
			!anyTermSelected.value ||
			v$.value.fimenu.$invalid ||
			fimenu.isSpectator ||
			matchingEmployees < requiredEmployees.length ||
			(fimenu.buyersOrderEnabled ? !fimenu.getCurrentBuyersOrder()?.areAllBucketsValid() : false) ||
			localIsEContracting ||
			submittingCreditApplication.value
		);
	}

	async function goToFinal() {
		//CHECK FOR PENDING CHECKLIST ITEMS
		//let currentSection = this.visibleSections.find(s => s.isActive);
		//isBusyFinalButton.value = true;
		//let canProceed = await checkChecklist(		//isBusyFinalButton.value = false;

		//if (!canProceed) return;

		if (!fimenu.isDealLocked() && fimenu.buyersOrderEnabled && fimenu.buyersOrderUpdateRequired) {
			await buyersOrderHelper.resetBuyersOrderAsync(fimenu);
		}

		if (fimenu.hasCoverageTermOrPaperwork() && !fimenu.hasPaperworkPacket()) {
			await applyProductItemizationRules();
		}

		//CHECK IF WE ARE DOING A CDK SYNC
		if (fimenu.store.cdkSettings.sync != null && fimenu.store.cdkSettings.sync.push) {
			pushToCDK();
		} else {
			await handleContinue();
		}
	}

	async function applyProductItemizationRules() {
		const response = await api.settings.getStateProducts(
			fimenu.store.storeState,
			JSON.stringify({
				fimenu: fimenu.getSanitizedData(),
				store: fimenu.store,
			}),
		);

		fimenu
			.getCurrentBuyersOrder()
			?.getAllItemsForBucketTypeAndProfitFlag('Products')
			.forEach((i: any) => {
				i.setProductItemization(response.data);
			});
	}

	function pushToCDK() {
		const cdkDealNumber = fimenu.getCDKDealNumber();

		isBusyFinalButton.value = true;
		EventBus.emit('WaitingCDK');

		return api.dart
			.checkIfDealExistsOrLockedInCDK(cdkDealNumber, $global.selectedStore.storeCode)
			.then(response => {
				if (response && response.data && !response.data.syncPush) {
					//WE DONT DO CDK PUSH IN THIS STORE
					EventBus.emit('CDKPush', {
						pushing: false,
						postFunction: openFinalModal,
					});
				} else if (response && response.data && !response.data.isExists) {
					//DEAL DOESNT EXIST IN CDK
					EventBus.emit('CDKPushFinish');
					$modal.open(modalInfo, {
						name: 'modalInfo',
						passedData: {
							title: `Deal  doesn't exist in CDK`,
							info: `Deal ${cdkDealNumber} is not a deal in CDK for store ${$global.selectedStore.storeName}. Make sure you have the correct deal number and store selected.`,
							acceptText: 'OK',
						},
						backdrop: false,
					});
				} else if (response && response.data && response.data.isLocked) {
					//DEAL IS LOCKED
					EventBus.emit('CDKPushFinish');
					$modal.open(modalInfo, {
						name: 'modalInfo',
						passedData: {
							title: 'Deal Is Locked in CDK',
							info: `Deal ${cdkDealNumber} is currently open in CDK. Please close the deal and try again.`,
							acceptText: 'OK',
						},
						backdrop: false,
					});
				} else {
					//START SYNC
					EventBus.emit('CDKPush', {
						pushing: true,
						postFunction: openFinalModal,
					});
				}
			})
			.finally(() => {
				isBusyFinalButton.value = false;
			});
	}

	function openFinalModal(syncResponse?: any) {
		$modal.open(modalFIFinalStep, {
			name: 'modalFIFinalStep',
			passedData: {
				fimenu: fimenu,
				checkChecklistFunc: checkChecklist,
				license: v$.value,
				syncResponse: syncResponse,
				products: fimenu.storeProducts,
			},
			backdrop: false,
			postFunction: () => finalizeFI(),
		});
	}

	function openPaperworkErrorsModal() {
		$modal.open(modalPaperworkErrors, {
			name: 'modalPaperworkErrors',
			passedData: {
				packetId: fimenu.id,
				paperwork: fimenu.paperwork,
				fimenu: fimenu,
				rootName: 'Deal #' + fimenu.dealNumber + ' - ' + fimenu.storeCode,
			},
			backdrop: true,
		});
	}

	function updateRatesIfNeeded() {
		if (
			!$global.isAdminView &&
			!fimenu.isDealLocked() &&
			fimenu.isRatingRequired() &&
			sections.value.some(s => s.name === FIMenuSectionEnumsHelper.getName(FIMenuSection.FIMenu) && s.isActive)
		) {
			rateProducts();
		}
	}

	async function rateProducts() {
		isBusy.value = true;
		fimenu.addToLog(ENUMS.LOG_WHERE.RATE, ENUMS.LOG_HOW.ASYNC.STARTED, ENUMS.LOG_WHAT.STEP_STARTED);

		try {
			await fimenu.getProductsRates();

			//update oil type Availability if we have maintenance
			setOilTypesNotAvailable();

			await updatePENProducts();

			if (fimenu.selectedProviders.find((sp: any) => sp.productType === ENUMS.PRODUCT_TYPES.MAINTENANCE)?.provider != null && !isSelectedOilTypeAvailable()) {
				openModalOil();
			}
		} catch (err) {
			console.error('error', err);
		} finally {
			fimenu.addToLog(ENUMS.LOG_WHERE.RATE, ENUMS.LOG_HOW.ASYNC.DONE, ENUMS.LOG_WHAT.STEP_FINISHED);
			isBusy.value = false;
		}
	}

	async function rateProductsAllForceRepriceAll() {
		//force reprice all
		fimenu.selectedProviders = [];

		//reset coverage terms
		fimenu.resetDefaultCoverageTerms();

		//re-rate
		rateProducts();
	}

	function getPaymentStartDate() {
		if (fimenu.dealType.toLowerCase() === 'finance' && fimenu.loanTerms && (fimenu.loanTerms.selectedDaysToFirstPayment ?? 30))
			return $filters.prettyDate(util.toMoment(fimenu.dealDate).add(fimenu.loanTerms.selectedDaysToFirstPayment ?? 30, 'days'));
		else return $filters.prettyDate(util.toMoment(fimenu.dealDate).add(30, 'days'));
	}

	async function handleSubmitDealJacketToRouteOne() {
		return new Promise<any>((resolve, reject) => {
			try {
				if (fimenu.isCash()) return resolve(null);

				const canSubmit = fimenu.store?.storeSettings?.submitCustomersToFinanaceInstitutions == true || fimenu.creditApplicationsEnabled == true;
				if (!canSubmit) return resolve(null);
				if (!fimenu.isEContracting) return resolve(null);

				// Call SubmitDealJacket and wait for its Promise to resolve
				SubmitDealJacket(fimenu)
					.then(result => resolve(result))
					.catch(error => {
						console.error(error);
						resolve(null);
					});
			} catch (err) {
				console.error(err);
				resolve(err);
			}
		});
	}

	function checkDealDate(fimenu?: FIMenu | null): Promise<boolean> {
		return new Promise(async resolve => {
			try {
				if (!fimenu) return resolve(false);
				const isOutdated = isDealDateOutdated(fimenu);

				if (!isOutdated) return resolve(false);

				util.modalConfirmation(
					'The deal date is not today. You must unselect coverage and deal term and update the date to today to generate paperwork',
					'Update',
					async () => {
						try {
							sectionLoading.value = true;
							nextTick(() => {
								updateDealDate(fimenu);
								moveToLastAccessibleSection();
								resolve(true);
							});
						} catch (error) {
							console.error('Error updating deal date:', error);
							resolve(false);
						} finally {
							sectionLoading.value = false;
						}
					},
					'Cancel',
					() => resolve(false),
					'Invalid Deal Date',
				);
			} catch (error) {
				console.error('Error checking deal date:', error);
				resolve(false);
			}
		});
	}

	async function finalizeFI(controlNumber?: any, skipChecklist = false) {
		if (await fimenu.checkForFraud()) return;

		const isOutdated = isDealDateOutdated(fimenu);

		if (isOutdated) {
			await checkDealDate(fimenu);
			return;
		}

		if (!skipChecklist) {
			isBusySaving.value = true;
			const canProceed = await checkChecklist(undefined, () => finalizeFI(controlNumber, true));
			isBusySaving.value = false;

			if (!canProceed) return;
		}

		let message = '';

		if (!user.value.isAdmin) {
			//change the ownership of the documents just if is not admin, in case we need to play with production deal
			fimenu.fiManagerName = user.value.EmployeeName;
			fimenu.fiManagerCode = user.value.EmployeeCode;
		}

		const { customer, coCustomer, hasCoSigner } = fimenu;

		if (!customer.isEntity && !customer.ssnLast4) {
			message = `${customer.fullName} is missing their SSN.`;
		}

		if (hasCoSigner && !coCustomer.isEntity && !coCustomer.ssnLast4) {
			if (message) {
				message = `${customer.fullName} and ${coCustomer.fullName} are missing their SSN.`;
			} else {
				message = `${coCustomer.fullName} is missing their SSN.`;
			}
		}

		if (fimenu.buyersOrderEnabled && !!message && fimenu.dealType != 'Cash') {
			return util.modalInformation(
				message,
				() => {
					return;
				},
				'Missing Customer Information',
				'Ok',
			);
		}

		//WE ALREADY HAVE PAPERWORK, SO GO TO NEXT SECTION
		if (fimenu.hasPaperworkPacket()) {
			handleContinue();
		} else {
			const response = await submitCreditApplication_SP();

			if (!response) {
				util.toastr(
					'error',
					'Credit Application',
					"There was an error submitting your credit application. If you'd like to continue please select a different application.",
				);
				return;
			}

			// Get the lender to get the settings from.
			const lender = $global.Lenders.find(l => l.lenderCode === fimenu.lender.lenderCode);

			// Each promise resolves from within wether they should be executed or not.
			if (fimenu.isEContractEnabled && lender?.settings.blockEContract == false) {
				// Does all eContract checks and validations.
				// This method returns wether we can continue or not.
				const canContinueEContract = await handleEContractingStuff();
				if (!canContinueEContract) return;
			}

			const executionPromises = [handleSubmitDealJacketToRouteOne(), getPaperwork(), copyAndAssociateCreditReport(), transferPlate(), submitCreditApplication_SP()];

			//GENERATE PAPERWORK
			try {
				await Promise.all(executionPromises);
				await updateInventory(fimenu, false);
			} catch (error) {
				console.error(error);
				util.toastr('error', 'Paperwork', error);
			} finally {
				await handleContinue();
				EventBus.emit('paperworkReady');
			}
		}
	}

	function copyAndAssociateCreditReport() {
		if (fimenu.customer?.creditReport?.id) {
			if (fimenu.coCustomer?.creditReport?.id) {
				return [
					api.creditreport.copyAndAssociateCreditReport(fimenu.id, fimenu.customer.creditReport.id),
					api.creditreport.copyAndAssociateCreditReport(fimenu.id, fimenu.coCustomer.creditReport.id),
				];
			} else {
				return api.creditreport.copyAndAssociateCreditReport(fimenu.id, fimenu.customer.creditReport.id);
			}
		}

		return Promise.resolve();
	}

	/**
	 * Submits a credit application to ally if the selected lender is ally AND we have a soft pull.
	 * this method is only meant to be called on paperwork generation.
	 * @returns A promise that resolves wether we can continue or not
	 *
	 */
	function submitCreditApplication_SP() {
		return new Promise(async (resolve, reject) => {
			try {
				submittingCreditApplication.value = true;

				const selectedCreditApplication = fimenu.dealJacket.getSelectedApplication();

				if (!$global.selectedStore.storeSettings.softPullAllyProgram) {
					return resolve(true);
				}

				if (!fimenu.creditApplicationsEnabled) {
					LogRocket.log('submitCreditApplication_SP: Credit applications are not enabled');
					return resolve(true);
				}

				if (!fimenu.buyersOrderEnabled) {
					LogRocket.log('submitCreditApplication_SP: Buyers order is not enabled');
					return resolve(true);
				}

				if (fimenu.dealJacket.getSelectedApplication() == null) {
					LogRocket.log('submitCreditApplication_SP: No application selected');
					return resolve(true);
				}

				// Ensure we don't have any other hard pull application for the same bank that has a softpull application.
				const hasHardPull = fimenu.dealJacket.applications.some(
					app => app.isSoftPull == false && app.lender.lenderCode == selectedCreditApplication.lender.lenderCode,
				);
				if (hasHardPull) {
					LogRocket.log('submitCreditApplication_SP: Has hard pull already');
					return resolve(true);
				}

				const lender = $global.Lenders.find(l => l.lenderCode === fimenu.lender.lenderCode);

				if (!lender) {
					LogRocket.log('submitCreditApplication_SP: Lender not found');
					return resolve(false);
				}

				// Create a submisison object based off the current deal information.
				const submissionInformation = new FIDealJacketAdditionalInformation({
					buyRate: fimenu.getSelectedDealTerm().buyrate,
					term: fimenu.getSelectedDealTerm().term,
					sellRate: fimenu.getSelectedDealTerm().sellrate,
					allowLendersPassthrough: false,
					inventoryType: fimenu.inventoryType as InventoryTypeValues,
					selectedBookValue: fimenu.dealJacket.getSelectedApplication().vehicleBookValue,
					dynamicFields: new FIDynamicFields(),
				});

				const response = await SubmitCreditApplication(fimenu, submissionInformation, lender);

				if (response.statusCode != 200) {
					LogRocket.log('submitCreditApplication_SP_PROGRAM_ALLY: Error submitting credit application', response);
					return resolve(false);
				}

				const concatMessage = response?.messages?.join(', ') ?? null;
				const parsedResponse = new SubmitCreditApplicationResponse(response.payload);
				const application = parsedResponse.application;

				// Add the application to the deal jacket.
				fimenu.dealJacket.addApplication(application);

				// select the current application
				fimenu.dealJacket.applications.forEach(app => {
					if (app.id == application.id) app.selected = true;
					else app.selected = false;
				});

				util.toastr('success', 'Credit Application', concatMessage?.trim() ? concatMessage : 'Submitted successfully.');

				return resolve(true);
			} catch (err) {
				console.error(err);
				return resolve(false);
			} finally {
				submittingCreditApplication.value = false;
			}
		});
	}

	/**
	 * Handles the eContracting process and validation.
	 * @returns A boolean indicating if the process can continue to generate paperwork.
	 *
	 */
	async function handleEContractingStuff(): Promise<boolean> {
		try {
			isEContracting.value = true;
			// Use the centralized helper method to handle eContract status
			const result = await HandleEContractStatus(fimenu, true, true);
			return result.canContinue;
		} catch (err) {
			console.error(err);
		} finally {
			isEContracting.value = false;
		}
	}

	function transferPlate() {
		return new Promise(async (resolve, reject) => {
			try {
				const isPlateTransfer = fimenu.vehicle.registrationInfo.isPlateTransfer;

				// Check if we can actually do a transfer.
				if (!fimenu.buyersOrderEnabled || !IsPlateTransactionsEnabled(fimenu)) return resolve(false);
				// IF we're not doing anything, kill it here.
				if (!isPlateTransfer) return resolve(false);
				// Lets check if the user has credentials.
				const response = await api.plateTransactions.hasCredentials();
				if (!response.data) return resolve(false);
				// We should only automatically generate if it's the first one.
				await handlePlateTransaction(fimenu, PlateTransactionType.Transfer, 'DMV Transaction Completed.', false);
				return resolve(true);
			} catch (err) {
				console.error(err);
				util.toastr('error', 'Paperwork', err);
				return resolve(err);
			}
		});
	}

	function getPaperwork() {
		return new Promise((resolve, reject) => {
			fimenu.cleanUpCustomers();

			EventBus.emit('paperworkStarted');

			//PREP fimenu OBJECT FOR PAPERWORK

			api.fimenu
				.getPaperwork(fimenu)
				.then(response => {
					if (response && response.data) {
						fimenu.paperwork = new FIMenuPaperwork(response.data);
						//SET DOCUMENT ISOPEN
						fimenu.paperwork.currentPacket().documents.forEach((doc: any) => {
							doc.isOpen = false;
						});
						util.toastr('success', 'Paperwork Success!', 'Paperwork is ready');
					} else {
						util.toastr('error', 'Paperwork', 'Unknown Error');
					}
				})
				.catch(function (error) {
					util.toastr('error', 'Paperwork', error);
					resolve(error);
				})
				.finally(() => {
					resolve(true);
				});
		});
	}

	function isVideoSelected() {
		return selectedVideos.value.length === 0 ? true : false;
	}

	function resetSelectedForStreaming() {
		selectedForStreaming.value = [];
	}

	async function getCreditReportWhenInitialized() {
		const customerId = fimenu.customer?.id;
		if (customerId) {
			try {
				const { data: customerReport } = await api.creditreport.getByCustomerId(customerId, fimenu.isDealLocked() ? fimenu.id : null);
				fimenu.customer.creditReport = new FIMenuCreditReport(customerReport);
			} catch (error) {
				console.error(error);
			}
		}

		const coCustomerId = fimenu.coCustomer?.id;
		if (coCustomerId) {
			try {
				const { data: coCustomerReport } = await api.creditreport.getByCustomerId(coCustomerId, fimenu.isDealLocked() ? fimenu.id : null);
				fimenu.coCustomer.creditReport = new FIMenuCreditReport(coCustomerReport);
			} catch (error) {
				console.error(error);
			}
		}
	}

	async function startAutoCompleteScan(isQuoteRequested?: boolean) {
		// Starts an insurance scan on the customer with AutoComplete
		const promiseList = [Promise.resolve(startAutoCompleteInsuranceScan())];

		if (isQuoteRequested) promiseList.push(Promise.resolve(startAutoCompleteQuoteRequest()));

		await Promise.allSettled(promiseList);
	}

	async function startAutoCompleteInsuranceScan() {
		try {
			// AutoComplete will reject anyone with an address outside the US
			if (fimenu.customer.country !== 'US') return;

			const response = await api.autoComplete.createVerificationFromDeal(fimenu.id, fimenu.dealKind, fimenu.storeCode, fimenu.coCustomer.country === 'US');

			if (!response?.data || response.data.message) throw new Error(response?.data?.message ?? 'No response from server.', { cause: response });

			response.data.results.forEach((d: any) => {
				if (d.message) throw new Error(d.message, { cause: d });
			});
		} catch (err) {
			console.warn('COULD NOT START AUTOCOMPLETE INSURANCE SCAN: ', err);
		}
	}

	async function startAutoCompleteQuoteRequest() {
		try {
			// AutoComplete will reject anyone with an address outside the US
			if (fimenu.customer.country !== 'US') return;

			const quoteResponse = await api.autoComplete.createLeadFromDeal(fimenu.id, fimenu.dealKind, fimenu.storeCode);
			if (!quoteResponse?.data || quoteResponse.data.message) throw new Error(quoteResponse?.data?.message ?? 'No response from server.', { cause: quoteResponse });

			quoteResponse.data.results.forEach((d: any) => {
				if (d.message) throw new Error(d.message, { cause: d });
			});
		} catch (err) {
			console.warn('COULD NOT FETCH AUTOCOMPLETE INSURANCE QUOTE: ', err);
		}
	}

	function clearVehicleInformation() {
		if (fimenu.isDealLocked()) return;
		fimenu.vehicle.make = null;
		fimenu.vehicle.model = null;
		fimenu.vehicle.modelYear = null;
		fimenu.vehicle.style = null;
	}

	function onNotifyUserDealStructureChanged() {
		util.modalConfirmation(
			"We've detected a change in the deal structure which requires us to reconfigure and recalculate the figures for the buyer's order.",
			'Close',
			null,
			null,
			null,
			'NOTICE: Deal Structure Update',
			true,
			"Any manual adjustments you've made to any fee (not just state fees) might be reset to their default values due to this update. After the recalculation is complete, please ensure to review and, if necessary, readjust these figures to ensure accuracy.",
		);
	}

	const validations = computed(() => {
		if (fimenu == null || fimenu.customer == null) return {};

		const fimenuValidation = fimenu.validation();
		//Set Vehicle Min Miles to Last CarFax Odo or 1 if All Pre Reqs Do Not Exist
		const vehichleMinMiles =
			!$global.isAdminView &&
			fimenu.carFax.lastOdometerReading &&
			settings.lookups.carFaxOdometerMaxOffset &&
			fimenu.carFax.lastOdometerReading - fimenu.vehicleMiles > settings.lookups.carFaxOdometerMaxOffset
				? fimenu.carFax.lastOdometerReading
				: 1;
		const validations = {
			fimenu: {
				dealNumber: { required },
				dealDate: fimenuValidation.dealDate,
				dealType: { required },
				language: fimenuValidation.language,
				inventoryType: { required },
				customer: fimenuValidation.customer,
				hasCoSigner: fimenuValidation.hasCoSigner,
				coCustomer: fimenuValidation.coCustomer,
				preloads: fimenuValidation.preloads,
				vipRewardNumber: fimenuValidation.vipRewardNumber,
				otdBase: { required } as any,
				dealAddressesQuestions: fimenu.dealAddressesQuestions.map(() => ({
					answer: {
						required: requiredIf(() => fimenu.buyersOrderEnabled),
					},
				})),
				dealAddresses: { ...fimenuValidation.dealAddresses },
				downPayments: {},
				vin: {
					required,
					validVIN,
				},
				stockNumber: { required },
				vehicleMiles: {
					required,
					maxValue: false,
					minValue: minValue(vehichleMinMiles),
				},
				customersInfo: FIMenuCustomersInfo.validation(fimenu),
				vehicleWarranty: {
					warrantyStartDate: {
						isValid: (value?: any) => validInServiceDate(value, fimenu.dealDate, fimenu.vehicle.modelYear),
					} as any,
					warranties: {
						basic: {
							months: { required },
							miles: { required },
						},
						drivetrain: {
							months: { required },
							miles: { required },
						},
					},
					isLoanerIncluded: { required },
				},
				vehicleOil: { required },
				vehicle: {
					modelYear: {
						required,
						minLength: minLength(4),
						validVehicleYear: () => validVehicleYear(fimenu.vehicle.modelYear),
					},
					make: {
						required,
						isValid: () => validVehicleMake(fimenu, fimenu.store.storeSettings, dealMakeId.value),
					},
					model: { required },
					otherVehicleInfo: {
						MPGCity: { required, decimal, minValue: minValue(0) },
						MPGCombined: { required, decimal, minValue: minValue(0) },
						MPGHighway: { required, decimal, minValue: minValue(0) },
						Weight: { required, minValue: minValue(0) },
						GVWR: { required, minValue: minValue(0) },
					},
					hasFiveDigitOdometer: { required },
					mileageStatus: { required },
					milesPerYear: { required },
					fuelType: { required },
					exteriorColor: { required },
					primaryBodyType: { required },
					vehicleSurcharges: fimenu.vehicle.vehicleSurcharges.map(() => ({
						validSurcharge,
					})),
					bookValues: {
						...fimenu.vehicle.bookValues.map(() => VehicleBookValue.validation(fimenu)),
						isValid: () => {
							// Non BO Deal.
							if (!fimenu.buyersOrderEnabled) return true;

							// additionals validations add them to "GetValidationForBookValues" as they are used to display the message in the BO
							// To not have to recreate the same logic in both places.
							const premadeValidation = getValidationForBookValues(fimenu);

							for (const [_, validation] of Object.entries(premadeValidation)) {
								if (!validation.valid()) return false;
							}

							return true;
						},
						valid: {} as (arg: any) => boolean,
					},
					registrationInfo: {} as any,
				},
				isVehicleDelivered: { required },
				isEContracting: { required },
				sellingPrice: { required } as any,
				externalDMSDealNumber: fimenuValidation.externalDMSDealNumber,
				otd: { required } as any,
				otdFinal: { required },
				nonBuyersOrderFinalNumbers: {
					frontEndProfit: {
						required: requiredIf(() => !fimenu.buyersOrderEnabled),
					},
				},
				msrp: {
					//required: requiredIf(() => !fimenu.buyersOrderEnabled),
					maxValue: false,
					minValue: minValue(1),
				},
				invoice: {},
				lender: {
					lenderCode: { required },
					//lenderName: { required },
					//lenderAddress: { required },
					//lenderAddressExtraMake: {},
					//lenderCity: { required },
					//lenderZip: { required, validZIPUS },
					//lenderState: { required }
				},
				leaseTerms: {
					...fimenu.leaseTerms.validation(fimenu, FIMenuLeaseTerms.validationTypes.TERMS),
				},
				loanTerms: {
					...fimenu.loanTerms.validation(fimenu, FIMenuLoanTerms.validationTypes.TERMS),
				},
				insurance: fimenuValidation.insurance,
				tradeIns: fimenuValidation.tradeIns,
				hasOtherTradeIns: {
					required: requiredIf(() => fimenu.buyersOrderEnabled),
				},
			},
		};

		if (fimenu.buyersOrderEnabled) {
			validations.fimenu.invoice = {
				//required,
				maxValue: false,
				minValue: minValue(1),
			};

			validations.fimenu.vehicle.bookValues.valid = (values?: any) => !fimenu.isNew() || values.some((value: any) => value.source === BookValue.Manufacturer);
			validations.fimenu.downPayments = fimenuValidation.downPayments;

			validations.fimenu.vehicle.registrationInfo = {
				primaryUsage: { required },
				deliveryMethod: { required },
				isPlateTransfer: { required },
				plateNumber: {
					required: requiredIf(() => fimenu.vehicle.registrationInfo.isPlateTransfer),
				},
				plateState: {
					required: requiredIf(() => fimenu.vehicle.registrationInfo.isPlateTransfer),
				},
				registrationLengthInMonths: {
					required: requiredIf(() => fimenu.vehicle.registrationInfo.isPlateTransfer),
				},
				currentPlateExpirationDate: {
					validDate,
					required: requiredIf(() => fimenu.vehicle.registrationInfo.isPlateTransfer),
				},
				titledUnder: { required },
				//controlNumber: {required: requiredIf((registrationInfo) => registrationInfo.transactionType == ENUMS.PLATE_TRANSACTIONS_TYPES.NewTempPlate )},
				//transactionType: { required },
			};

			if (fimenu.vehicle.registrationInfo.primaryUsage == VehiclePrimaryUsage.EXPORT) {
				validations.fimenu.vehicle.registrationInfo.freightForwarderInfo = {
					name: { required },
					address: {
						address: { required },
						addressExtra: {
							required: requiredIf(() => fimenu.vehicle.registrationInfo.freightForwarderInfo.address.usingAddressExtra),
						},
						city: { required },
						state: { required },
						zip: {
							required,
							validZIPUS: () => {
								if (fimenu.vehicle.registrationInfo.freightForwarderInfo.address.usingUSAddress != false) {
									return validZIPUS(fimenu.vehicle.registrationInfo.freightForwarderInfo.address.zip);
								}
								return true;
							},
							validZIPInternational: () => {
								if (fimenu.vehicle.registrationInfo.freightForwarderInfo.address.usingUSAddress == false) {
									return validZIPInternational(fimenu.vehicle.registrationInfo.freightForwarderInfo.address.zip);
								}
								return true;
							},
						},
						county: {
							required: requiredIf(() => fimenu.vehicle.registrationInfo.freightForwarderInfo.address.usingUSAddress),
						},
						country: { required },
					},
					phoneNumber: {
						required,
						minLength: minLength(10),
						maxLength: maxLength(10),
					},
					licenseNumber: { required, validLicense },
				};
				validations.fimenu.vehicle.registrationInfo.shippingCompanyInfo = {
					name: { required },
					address: {
						address: { required },
						addressExtra: {
							required: requiredIf(() => fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.usingAddressExtra),
						},
						city: { required },
						state: { required },
						zip: {
							required,
							validZIPUS: () => {
								if (fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.usingUSAddress != false) {
									return validZIPUS(fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.zip);
								}
								return true;
							},
							validZIPInternational: () => {
								if (fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.usingUSAddress == false) {
									return validZIPInternational(fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.zip);
								}
								return true;
							},
						},
						county: {
							required: requiredIf(() => fimenu.vehicle.registrationInfo.shippingCompanyInfo.address.usingUSAddress),
						},
						country: { required },
					},
					phoneNumber: {
						required,
						minLength: minLength(10),
						maxLength: maxLength(10),
					},
					licenseNumber: { required, validLicense },
				};
			}

			validations.fimenu.dealAddressesQuestions = fimenu.dealAddressesQuestions.map(() => ({
				answer: { required },
			}));

			validations.fimenu.sellingPrice = {};
			validations.fimenu.otdBase = {};
			validations.fimenu.otd = {};
		} else {
			validations.fimenu.vehicle.registrationInfo = {
				plateNumber: {},
				plateState: {},
				isPlateTransfer: {},
				registrationLengthInMonths: {},
				currentPlateExpirationDate: {},
			};
		}

		if (fimenu.inventoryType != 'New' || !util.isNull(fimenu.vehicleWarranty.warrantyStartDate)) {
			validations.fimenu.vehicleWarranty.warrantyStartDate = {
				isValid: (value: any) => validInServiceDate(value, fimenu.dealDate, fimenu.vehicle.modelYear),
				required,
			};
		}

		if (anyTermSelected.value) {
			validations.fimenu.customer.address = { required };
			validations.fimenu.customer.city = { required };
			validations.fimenu.customer.state = { required };
			validations.fimenu.customer.zip = { required };
		}

		if (fimenu.customer.usingAddressExtra) {
			validations.fimenu.customer.addressExtra = { required };
		}

		if (fimenu.coCustomer.usingAddressExtra) {
			validations.fimenu.coCustomer.addressExtra = { required };
		}

		if (fimenu.isCash() && !fimenu.isFinance() && !fimenu.isLease()) {
			validations.fimenu.lender = {
				lenderCode: { required },
			};
		}

		return validations;
	});

	const v$ = useVuelidate(validations, { fimenu: reactiveFimenu });

	defineExpose({
		isDisabledCustomerInformation,
		isDisabledFIMenu,
		isDealChecklistEnabled,
		isAllPaperworkActivated,
		isDealLocked,
		panelMenuRef,
		hasValidLeaseOrLoanTerms,
		fimenu,
	});
</script>
<style>
	.cocustomer-container {
		margin-bottom: 300px;
	}

	.sidemenu-inside-container fieldset:disabled .trade-ins-container i.close-button,
	.sidemenu-inside-container fieldset:disabled .customer-section-container i.close-button {
		display: none;
	}

	.sidemenu-inside-container fieldset:disabled .customer-radio-button-inline {
		pointer-events: none;
	}

	.fimenupage .fimenu-section-wrapper .loading-saturn-anim.fade-in.IsBusySectionComponent-container {
		height: calc(100% - 75px);
	}

	.fimenubasic .sidemenu-main .sidemenu-contents {
		border-top: none !important;
	}

	.fimenubasic .sidemenu-menu {
		border-top: none !important;
	}

	.fimenubasic .purchase-figures-container {
		height: 100%;
		margin-bottom: unset !important;
	}

	.purchase-figures-container > * {
		height: 99% !important;
		overflow: hidden;
	}

	.purchase-figures-container-nonbo > * {
		height: 99% !important;
		overflow: visible;
	}

	.fimenubasic .purchase-figures-container .panel .panel-body {
		overflow-y: auto;
	}
</style>
